var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* tslint:disable */
/* eslint:disable */
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'blog-app-users' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign(__assign({}, defaultConfig), restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
export var initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 69 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'blog-app-users' });
    }
    ;
    /**
    * @typedef {Object} oneAppSharePostButtonClick1316Params
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - post page
    * @property {string} post_id - post_id
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: OneApp share post button click. Evid: 1316.
     * Event description: user clicked on share button in oneapp top bar.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: post page
     *
     * post_id - Type: string. Desc: post_id
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {oneAppSharePostButtonClick1316Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppSharePostButtonClick1316 = function (params) {
        return this.bi.log(__assign({ evid: 1316 }, params));
    };
    /**
    * @typedef {Object} oneAppManageCategoriesButtonInThreeDotsClickedParams
    * @property {string} button_name - button name in three dots categories menu
    * @property {string} category_id - category_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - Where tabs was opened (Manage)
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: OneApp Manage Categories button in three dots clicked. Evid: 1311.
     * Event description: Button in categories three dots meniu clicked.
    
     * button_name - Type: string. Desc: button name in three dots categories menu
     *
     * category_id - Type: string. Desc: category_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: Where tabs was opened (Manage)
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {oneAppManageCategoriesButtonInThreeDotsClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppManageCategoriesButtonInThreeDotsClicked = function (params) {
        return this.bi.log(__assign({ evid: 1311 }, params));
    };
    /**
    * @typedef {Object} widgetAddClickAppBuilderParams
    * @property {string} element_type - recent post, custom feed, wix code
    * @property {GUID} id - unique widget id to connect to other events
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - Add Panel/6th button
    * @property {string} widget_id - widget_id
    **/
    /**
     * Name: widget add click (app builder). Evid: 701.
     * Event description: user clicks to add widget.
    
     * element_type - Type: string. Desc: recent post, custom feed, wix code
     *
     * id - Type: guid. Desc: unique widget id to connect to other events
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: Add Panel/6th button
     *
     * widget_id - Type: string. Desc: widget_id
     * @param {widgetAddClickAppBuilderParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.widgetAddClickAppBuilder = function (params) {
        return this.bi.log(__assign({ evid: 701 }, params));
    };
    /**
    * @typedef {Object} migrationLearnMoreClickParams
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_first - is it the first time the user opens this tab?
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} referral_info - referral_info
    * @property {string} role - role
    **/
    /**
     * Name: Migration -> Learn more click. Evid: 383.
     * Event description: triggered when users click on Maybe Learn more click.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_first - Type: bool. Desc: is it the first time the user opens this tab?
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * referral_info - Type: string. Desc: referral_info
     *
     * role - Type: string. Desc: role
     * @param {migrationLearnMoreClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationLearnMoreClick = function (params) {
        return this.bi.log(__assign({ evid: 383 }, params));
    };
    /**
    * @typedef {Object} blogFeedRenamedParams
    * @property {GUID} app_id - app_id (forum, blog, members)
    * @property {string} community_id - community_id (instance of members app)
    * @property {GUID} instance_id - instance_id
    * @property {string} language - language
    * @property {GUID} biToken - msid
    * @property {string} name - The new feed name
    * @property {string} old_name - The updated value
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: Blog Feed Renamed. Evid: 374.
     * Event description: When the user renames the Main blog feed from the BM.
    
     * app_id - Type: guid. Desc: app_id (forum, blog, members)
     *
     * community_id - Type: string. Desc: community_id (instance of members app)
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * language - Type: string. Desc: language
     *
     * biToken - Type: guid. Desc: msid
     *
     * name - Type: string. Desc: The new feed name
     *
     * old_name - Type: string. Desc: The updated value
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {blogFeedRenamedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.blogFeedRenamed = function (params) {
        return this.bi.log(__assign({ evid: 374 }, params));
    };
    /**
    * @typedef {Object} oneAppOpenedAllPostsAnalyticsParams
    * @property {string} filter_name - The analytics Period (1D, 7D, 28D, all time)
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} role - user role
    **/
    /**
     * Name: OneApp Opened All Posts Analytics. Evid: 1318.
     * Event description: Whenever a user opens Post Analytics (all posts).
    
     * filter_name - Type: string. Desc: The analytics Period (1D, 7D, 28D, all time)
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: user role
     * @param {oneAppOpenedAllPostsAnalyticsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppOpenedAllPostsAnalytics = function (params) {
        return this.bi.log(__assign({ evid: 1318 }, params));
    };
    /**
    * @typedef {Object} updateBlogModalShownParams
    * @property {GUID} instance_id - null
    * @property {string} modal_name - "Upgrade to the new blog".; "Magic Migration Blog Out of date"; "Magic Migration Blog Out of date - update options"
    * @property {GUID} biToken - null
    * @property {boolean} new_blog_valid - TRUE if new Blog is installed (nice to have)
    * @property {string} origin - origin - 6th button or right after opening Editor or some other place
    **/
    /**
     * Name: Magic Migration: Update blog modals (incl. success). Evid: 405.
     * Event description: Whenver the user sees the migration option - Migration message shown.
    
     * instance_id - Type: guid.
     *
     * modal_name - Type: string. Desc: "Upgrade to the new blog".; "Magic Migration Blog Out of date"; "Magic Migration Blog Out of date - update options"
     *
     * biToken - Type: guid.
     *
     * new_blog_valid - Type: bool. Desc: TRUE if new Blog is installed (nice to have)
     *
     * origin - Type: string. Desc: origin - 6th button or right after opening Editor or some other place
     * @param {updateBlogModalShownParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.updateBlogModalShown = function (params) {
        return this.bi.log(__assign({ evid: 405 }, params));
    };
    /**
    * @typedef {Object} authorOfflineDeletedParams
    * @property {GUID} author_id - Author id which was created
    * @property {string} author_role - Currently "Offline", might be reused later
    * @property {boolean} has_picture - TRUE if a picture is assigned for created author (nice to have)
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Author (offline) deleted. Evid: 367.
     * Event description: Deleted an offline author.
    
     * author_id - Type: guid. Desc: Author id which was created
     *
     * author_role - Type: string. Desc: Currently "Offline", might be reused later
     *
     * has_picture - Type: bool. Desc: TRUE if a picture is assigned for created author (nice to have)
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {authorOfflineDeletedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.authorOfflineDeleted = function (params) {
        return this.bi.log(__assign({ evid: 367 }, params));
    };
    /**
    * @typedef {Object} postSoftDeleteParams
    * @property {GUID} instance_id - null
    * @property {string} language - for multilingual
    * @property {string} language_id - the post stable if of the translated post
    * @property {GUID} biToken - null
    * @property {string} origin - post page, post editor, drafts
    * @property {string} post_id - post id
    * @property {GUID} post_stable_id - post stable id
    **/
    /**
     * Name: Post soft delete. Evid: 333.
     * Event description: When a post is moved to trash.
    
     * instance_id - Type: guid.
     *
     * language - Type: string. Desc: for multilingual
     *
     * language_id - Type: string. Desc: the post stable if of the translated post
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: post page, post editor, drafts
     *
     * post_id - Type: string. Desc: post id
     *
     * post_stable_id - Type: guid. Desc: post stable id
     * @param {postSoftDeleteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postSoftDelete = function (params) {
        return this.bi.log(__assign({ evid: 333 }, params));
    };
    /**
    * @typedef {Object} oldBlogGfppShownParams
    * @property {GUID} instance_id - null
    * @property {boolean} is_mobile - TRUE if it's mobile editor
    * @property {GUID} biToken - null
    * @property {string} widget_app - the name of widget/app - Blog Feed Single Post Page Featured Post Posts Lists Custom Feed Ticker Posts Gallery Tag Cloud Categories Archive
    **/
    /**
     * Name: Magic Migration: Old Blog GFPP shown. Evid: 403.
     * Event description: Shown of old blog gfpp.
    
     * instance_id - Type: guid.
     *
     * is_mobile - Type: bool. Desc: TRUE if it's mobile editor
     *
     * biToken - Type: guid.
     *
     * widget_app - Type: string. Desc: the name of widget/app - Blog Feed Single Post Page Featured Post Posts Lists Custom Feed Ticker Posts Gallery Tag Cloud Categories Archive
     * @param {oldBlogGfppShownParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oldBlogGfppShown = function (params) {
        return this.bi.log(__assign({ evid: 403 }, params));
    };
    /**
    * @typedef {Object} addBlogAppTypeOfBlogModalSelectionParams
    * @property {string} action - close or next
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} option - values: wix blog or members area
    **/
    /**
     * Name: Add blog app - members area install modal selection. Evid: 330.
     * Event description: Whenever the user adds the blog app to a site, the type of modal is displayed. This event records the user selection on the type of blog modal..
    
     * action - Type: string. Desc: close or next
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * option - Type: string. Desc: values: wix blog or members area
     * @param {addBlogAppTypeOfBlogModalSelectionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.addBlogAppTypeOfBlogModalSelection = function (params) {
        return this.bi.log(__assign({ evid: 330 }, params));
    };
    /**
    * @typedef {Object} editorSettingsPostPageBlogFeedShortcutsParams
    * @property {string} app_id - app_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - blog feed settings / post feed settings
    * @property {string} role - role
    * @property {string} tab_name - tab name inside post settings
    **/
    /**
     * Name: editor - Settings Post Page / Blog Feed Shortcuts. Evid: 349.
     * Event description: user clicks on Post Page tab inside the blog feed settings.
    
     * app_id - Type: string. Desc: app_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: blog feed settings / post feed settings
     *
     * role - Type: string. Desc: role
     *
     * tab_name - Type: string. Desc: tab name inside post settings
     * @param {editorSettingsPostPageBlogFeedShortcutsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.editorSettingsPostPageBlogFeedShortcuts = function (params) {
        return this.bi.log(__assign({ evid: 349 }, params));
    };
    /**
    * @typedef {Object} oneAppHappyMomentBannersParams
    * @property {string} action - closed, CTA - add banner, CTA - share
    * @property {string} banner_name - banner name - add banner to mobile, share your blog
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - Where tabs was opened (Manage)
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: OneApp Happy moment banners. Evid: 1315.
     * Event description: User did an action with a banner in Blog Manage.
    
     * action - Type: string. Desc: closed, CTA - add banner, CTA - share
     *
     * banner_name - Type: string. Desc: banner name - add banner to mobile, share your blog
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: Where tabs was opened (Manage)
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {oneAppHappyMomentBannersParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppHappyMomentBanners = function (params) {
        return this.bi.log(__assign({ evid: 1315 }, params));
    };
    /**
    * @typedef {Object} shareAfterPublishModalActionParams
    * @property {string} action - action user chose in modal (Not right now, close X, Facebook, Preview, Twitter, copy url, etc)
    * @property {boolean} dont_show_again - user marked don't show again
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post_id
    * @property {string} role - Role of the user - writer or admin
    **/
    /**
     * Name: Share after publish modal action. Evid: 316.
     * Event description: User chose action in Share after publish modal.
    
     * action - Type: string. Desc: action user chose in modal (Not right now, close X, Facebook, Preview, Twitter, copy url, etc)
     *
     * dont_show_again - Type: bool. Desc: user marked don't show again
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post_id
     *
     * role - Type: string. Desc: Role of the user - writer or admin
     * @param {shareAfterPublishModalActionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.shareAfterPublishModalAction = function (params) {
        return this.bi.log(__assign({ evid: 316 }, params));
    };
    /**
    * @typedef {Object} updateBlogModalActionParams
    * @property {string} action - action - close, learn more, update now
    * @property {string} choice - Content update/Content and design update
    * @property {string} choise - Content update/Content and design update - if user has both blogs (NOT USED)
    * @property {GUID} instance_id - null
    * @property {string} modal_name - "Upgrade to the new blog".; "Magic Migration Blog Out of date"; "Magic Migration Blog Out of date - update options"
    * @property {GUID} biToken - null
    * @property {boolean} new_blog_valid - if the site has new blog installed
    * @property {string} origin - origin (nice to have if we get any)
    **/
    /**
     * Name: Magic Migration: Update blog action. Evid: 406.
     * Event description: Action on migration message (shown - evid 405).
    
     * action - Type: string. Desc: action - close, learn more, update now
     *
     * choice - Type: string. Desc: Content update/Content and design update
     *
     * choise - Type: string. Desc: Content update/Content and design update - if user has both blogs (NOT USED)
     *
     * instance_id - Type: guid.
     *
     * modal_name - Type: string. Desc: "Upgrade to the new blog".; "Magic Migration Blog Out of date"; "Magic Migration Blog Out of date - update options"
     *
     * biToken - Type: guid.
     *
     * new_blog_valid - Type: bool. Desc: if the site has new blog installed
     *
     * origin - Type: string. Desc: origin (nice to have if we get any)
     * @param {updateBlogModalActionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.updateBlogModalAction = function (params) {
        return this.bi.log(__assign({ evid: 406 }, params));
    };
    /**
    * @typedef {Object} magicMigrationStartParams
    * @property {string} error_message - null
    * @property {GUID} instance_id - null
    * @property {string} migration_step - migration step error occuried
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Magic Migration: Client Migration Failed after posts copied (error message). Evid: 409.
     * Event description: Magic Migration Failed after copied posts, error message.
    
     * error_message - Type: string.
     *
     * instance_id - Type: guid.
     *
     * migration_step - Type: string. Desc: migration step error occuried
     *
     * biToken - Type: guid.
     * @param {magicMigrationStartParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.magicMigrationStart = function (params) {
        return this.bi.log(__assign({ evid: 409 }, params));
    };
    /**
    * @typedef {Object} bm3DotsClick334Params
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} role - role
    * @property {string} tabName - tab name
    **/
    /**
     * Name: Post List BM 3 dots click. Evid: 334.
     * Event description: Triggered when the user clicks on the 3 dots menu, on the post list within the Business Manager (BM).
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: role
     *
     * tabName - Type: string. Desc: tab name
     * @param {bm3DotsClick334Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bm3DotsClick334 = function (params) {
        return this.bi.log(__assign({ evid: 334 }, params));
    };
    /**
    * @typedef {Object} bulkActionsOptionChosenParams
    * @property {string} action - Restore, Delete, Add Category
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {number} postsCount - Number of posts selected
    * @property {string} tabName - Posts or Drafts
    **/
    /**
     * Name: BO: Bulk actions - option chosen. Evid: 346.
     * Event description: User did bulk action in Blog BO.
    
     * action - Type: string. Desc: Restore, Delete, Add Category
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * postsCount - Type: numeric. Desc: Number of posts selected
     *
     * tabName - Type: string. Desc: Posts or Drafts
     * @param {bulkActionsOptionChosenParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bulkActionsOptionChosen = function (params) {
        return this.bi.log(__assign({ evid: 346 }, params));
    };
    /**
    * @typedef {Object} migrationMigrationFailedParams
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_first - is it the first time the user opens this tab?
    * @property {string} migration_status - First time, In progress, Done, Failed (after finishing migration)
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} referral_info - referral_info
    * @property {string} role - role
    **/
    /**
     * Name: Migration -> Migration failed. Evid: 396.
     * Event description: triggered when Migration fails.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_first - Type: bool. Desc: is it the first time the user opens this tab?
     *
     * migration_status - Type: string. Desc: First time, In progress, Done, Failed (after finishing migration)
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * referral_info - Type: string. Desc: referral_info
     *
     * role - Type: string. Desc: role
     * @param {migrationMigrationFailedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationMigrationFailed = function (params) {
        return this.bi.log(__assign({ evid: 396 }, params));
    };
    /**
    * @typedef {Object} adiBlogSettingsOpenedParams
    * @property {boolean} adi_blog_settings_opened - 1 - ADI Blog settings opened
    * @property {GUID} instance_id - instance_id
    * @property {GUID} bi_token - MSID
    * @property {GUID} biToken - null
    * @property {string} role - Role of user - writer or admin
    **/
    /**
     * Name: ADI Blog settings opened. Evid: 326.
     * Event description: User opened blog settings in ADI.
    
     * adi_blog_settings_opened - Type: bool. Desc: 1 - ADI Blog settings opened
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * bi_token - Type: guid. Desc: MSID
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: Role of user - writer or admin
     * @param {adiBlogSettingsOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.adiBlogSettingsOpened = function (params) {
        return this.bi.log(__assign({ evid: 326 }, params));
    };
    /**
    * @typedef {Object} oneAppOpenedSinglePostAnalyticsClickParams
    * @property {string} filter_name - The analytics Period (1D, 7D, 28D, all time)
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - Most Recent Post, Most Viewed Posts, All Posts
    * @property {string} post_id - post id
    **/
    /**
     * Name: OneApp Opened single post analytics click. Evid: 1317.
     * Event description: whenever a user opens a post from the analytics screen.
    
     * filter_name - Type: string. Desc: The analytics Period (1D, 7D, 28D, all time)
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: Most Recent Post, Most Viewed Posts, All Posts
     *
     * post_id - Type: string. Desc: post id
     * @param {oneAppOpenedSinglePostAnalyticsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppOpenedSinglePostAnalyticsClick = function (params) {
        return this.bi.log(__assign({ evid: 1317 }, params));
    };
    /**
    * @typedef {Object} oneAppWidgetClickParams
    * @property {string} click_name - the label on the object clicked
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - origin
    * @property {string} post_id - post id - null if the click was not on a post
    * @property {GUID} post_stable_id - post stable id - null if the click was not on a post
    * @property {string} role - member role (owner, writer, member)
    * @property {string} widget_name - widget name
    **/
    /**
     * Name: OneApp - Widget click. Evid: 1340.
     * Event description: Tracks what the user clicked on any widget on the app.
    
     * click_name - Type: string. Desc: the label on the object clicked
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin
     *
     * post_id - Type: string. Desc: post id - null if the click was not on a post
     *
     * post_stable_id - Type: guid. Desc: post stable id - null if the click was not on a post
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * widget_name - Type: string. Desc: widget name
     * @param {oneAppWidgetClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppWidgetClick = function (params) {
        return this.bi.log(__assign({ evid: 1340 }, params));
    };
    /**
    * @typedef {Object} migrationUpdateUrlsModalOpenedParams
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_first - is it the first time the user opens this tab?
    * @property {string} migration_status - First time, In progress, Done (after finishing migration)
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} referral_info - referral_info
    * @property {string} role - role
    **/
    /**
     * Name: Migration -> Update URLs modal opened. Evid: 391.
     * Event description: triggered when Migration Update URLs modal actually open.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_first - Type: bool. Desc: is it the first time the user opens this tab?
     *
     * migration_status - Type: string. Desc: First time, In progress, Done (after finishing migration)
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * referral_info - Type: string. Desc: referral_info
     *
     * role - Type: string. Desc: role
     * @param {migrationUpdateUrlsModalOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationUpdateUrlsModalOpened = function (params) {
        return this.bi.log(__assign({ evid: 391 }, params));
    };
    /**
    * @typedef {Object} migrationPostCopyingStatusParams
    * @property {string} error_message - error message if unsuscessfull
    * @property {GUID} instance_id - null
    * @property {boolean} migration_succeed - 1 - yes / 0 - no
    * @property {GUID} bi_token - msid
    * @property {GUID} biToken - null
    * @property {number} num_posts_total - the number of total posts to copy
    * @property {number} num_posts_unsucc - the number of posts that weren't copied
    * @property {string} posts_with_too_large_content -
    * @property {number} too_large_post_count - null
    **/
    /**
     * Name: Migration -> Post Copying Status. Evid: 401.
     * Event description: Triggered when the migration completes both successfully or failed..
    
     * error_message - Type: string. Desc: error message if unsuscessfull
     *
     * instance_id - Type: guid.
     *
     * migration_succeed - Type: bool. Desc: 1 - yes / 0 - no
     *
     * bi_token - Type: guid. Desc: msid
     *
     * biToken - Type: guid.
     *
     * num_posts_total - Type: numeric. Desc: the number of total posts to copy
     *
     * num_posts_unsucc - Type: numeric. Desc: the number of posts that weren't copied
     *
     * posts_with_too_large_content - Type: string.
     *
     * too_large_post_count - Type: numeric.
     * @param {migrationPostCopyingStatusParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationPostCopyingStatus = function (params) {
        return this.bi.log(__assign({ evid: 401 }, params));
    };
    /**
    * @typedef {Object} migrationImportPageFirstStepOpenedParams
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_first - is it the first time the user opens this tab?
    * @property {string} migration_status - First time, In progress, Done (after finishing migration)
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} referral_info - referral_info
    * @property {string} role - role
    **/
    /**
     * Name: Migration -> Import page first step opened. Evid: 384.
     * Event description: triggered when Migration Import page first step actually open.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_first - Type: bool. Desc: is it the first time the user opens this tab?
     *
     * migration_status - Type: string. Desc: First time, In progress, Done (after finishing migration)
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * referral_info - Type: string. Desc: referral_info
     *
     * role - Type: string. Desc: role
     * @param {migrationImportPageFirstStepOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationImportPageFirstStepOpened = function (params) {
        return this.bi.log(__assign({ evid: 384 }, params));
    };
    /**
    * @typedef {Object} customizeChooseCategoriesClickWixReadsParams
    * @property {string} click_name - choose now, customise
    * @property {GUID} instance_id - instance
    * @property {GUID} biToken - msid
    * @property {string} origin - origin
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: Customize/choose categories click (Wix reads). Evid: 1329.
     * Event description: When the user clicks on the Customise or Choose now links on the main screen on wix reads, that link will take the user to the "Edit Categories" screen.
    
     * click_name - Type: string. Desc: choose now, customise
     *
     * instance_id - Type: guid. Desc: instance
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {customizeChooseCategoriesClickWixReadsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.customizeChooseCategoriesClickWixReads = function (params) {
        return this.bi.log(__assign({ evid: 1329 }, params));
    };
    /**
    * @typedef {Object} postUnscheduledParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post_id
    * @property {string} role - role
    **/
    /**
     * Name: post unscheduled. Evid: 337.
     * Event description: When the user unschedules a post.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post_id
     *
     * role - Type: string. Desc: role
     * @param {postUnscheduledParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postUnscheduled = function (params) {
        return this.bi.log(__assign({ evid: 337 }, params));
    };
    /**
    * @typedef {Object} errorMessageShowParams
    * @property {number} error_code - http code
    * @property {string} error_message - error message
    * @property {string} error_type - Error type
    * @property {GUID} instance_id - instance
    * @property {GUID} biToken - msid
    * @property {string} origin - origin
    * @property {string} role - role
    * @property {string} type - The way it was displayed: Tooltip, Modal, toast etc..
    **/
    /**
     * Name: error message show. Evid: 372.
     * Event description: whenever an error message is shown (tooltip, modal).
    
     * error_code - Type: numeric. Desc: http code
     *
     * error_message - Type: string. Desc: error message
     *
     * error_type - Type: string. Desc: Error type
     *
     * instance_id - Type: guid. Desc: instance
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin
     *
     * role - Type: string. Desc: role
     *
     * type - Type: string. Desc: The way it was displayed: Tooltip, Modal, toast etc..
     * @param {errorMessageShowParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.errorMessageShow = function (params) {
        return this.bi.log(__assign({ evid: 372 }, params));
    };
    /**
    * @typedef {Object} postEditorAddRemoveMediaElementParams
    * @property {string} action_type - Add or Remove
    * @property {string} adding_method - Click or drag n drop
    * @property {GUID} instance_id - instance_id
    * @property {string} media_content - the added media content if applicable (links, file name, html code)
    * @property {string} mediaOrigin - upload, embed, giphy  etc..
    * @property {string} media_type - image, video etc..
    * @property {GUID} bi_token - MSID
    * @property {GUID} biToken - null
    * @property {string} origin - sidebar or composer
    * @property {string} role - Role of the user - writer or admin
    * @property {string} tab_name - image, video, gallery, gif, html code (maybe not necessary)
    **/
    /**
     * Name: Post Editor - Add/Remove Media Element. Evid: 379.
     * Event description: When the user clicks the "+" in the post editor (sidebar or text area).
    
     * action_type - Type: string. Desc: Add or Remove
     *
     * adding_method - Type: string. Desc: Click or drag n drop
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * media_content - Type: string. Desc: the added media content if applicable (links, file name, html code)
     *
     * mediaOrigin - Type: string. Desc: upload, embed, giphy  etc..
     *
     * media_type - Type: string. Desc: image, video etc..
     *
     * bi_token - Type: guid. Desc: MSID
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: sidebar or composer
     *
     * role - Type: string. Desc: Role of the user - writer or admin
     *
     * tab_name - Type: string. Desc: image, video, gallery, gif, html code (maybe not necessary)
     * @param {postEditorAddRemoveMediaElementParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postEditorAddRemoveMediaElement = function (params) {
        return this.bi.log(__assign({ evid: 379 }, params));
    };
    /**
    * @typedef {Object} oneAppManageSearchClickedParams
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - Where tabs was opened (Manage)
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: OneApp Manage search clicked. Evid: 1307.
     * Event description: After clicking on search in OneApp manage.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: Where tabs was opened (Manage)
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {oneAppManageSearchClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppManageSearchClicked = function (params) {
        return this.bi.log(__assign({ evid: 1307 }, params));
    };
    /**
    * @typedef {Object} oneAppWixReadsScreenOpenParams
    * @property {GUID} app_id - app_id (forum, blog, members)
    * @property {string} community_id - community_id (instance of members app)
    * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} referral_info - external links - facebook, social networks. if from wix then null
    * @property {string} role - member role (owner, writer, member)
    * @property {string} screenName - home, explore
    * @property {GUID} site_member_id - site member id
    * @property {GUID} visitor_id - visitor id
    **/
    /**
     * Name: OneApp - wix reads - screen open. Evid: 1319.
     * Event description: triggered when user sees the home or the explore tabs in wix reads.
    
     * app_id - Type: guid. Desc: app_id (forum, blog, members)
     *
     * community_id - Type: string. Desc: community_id (instance of members app)
     *
     * instance_id - Type: guid. Desc: holds the child app (forum/blog) instance_id. or the members instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * referral_info - Type: string. Desc: external links - facebook, social networks. if from wix then null
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * screenName - Type: string. Desc: home, explore
     *
     * site_member_id - Type: guid. Desc: site member id
     *
     * visitor_id - Type: guid. Desc: visitor id
     * @param {oneAppWixReadsScreenOpenParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppWixReadsScreenOpen = function (params) {
        return this.bi.log(__assign({ evid: 1319 }, params));
    };
    /**
    * @typedef {Object} helperActionParams
    * @property {string} action - action in helper (close, learn more)
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} name - name of helper
    **/
    /**
     * Name: helper_action. Evid: 364.
     * Event description: Action on helper_showed (for custom feed confusion currently, can be reused later for others if needed) - close or learn more.
    
     * action - Type: string. Desc: action in helper (close, learn more)
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * name - Type: string. Desc: name of helper
     * @param {helperActionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.helperAction = function (params) {
        return this.bi.log(__assign({ evid: 364 }, params));
    };
    /**
    * @typedef {Object} oneAppWixReadsPostPublishedParams
    * @property {GUID} app_id - app_id (forum, blog, members)
    * @property {string} category_ids - category_ids. JSON array string
    * @property {number} character_count - The number of characters on the post
    * @property {string} galleries - will sent as array - [{ layout: 'masonry', count: 5}, { layout: 'whatever', count: 10 }]
    * @property {number} giphy_count - count of used  giphy gifs
    * @property {number} image_count - image_count in the post
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_edited - 0 - new post / 1 - edit (to know if its posted for first time)
    * @property {boolean} is_published - 0 - not published (draft) / 1 - published
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {GUID} original_msid - The msid where the post was published originally
    * @property {string} original_post_id - The original post id
    * @property {string} paid_plan_id - Array of paid plan ids
    * @property {string} post_id - post_id
    * @property {string} role - member role (owner, writer, member)
    * @property {GUID} site_member_id - site member id
    * @property {boolean} used_html - 0 - didnt used html component / 1 - used html component
    * @property {number} video_count - video_count in the post
    **/
    /**
     * Name: OneApp - Wix Reads Post published. Evid: 1322.
     * Event description: triggered when post published in oneapp Wix Reads.
    
     * app_id - Type: guid. Desc: app_id (forum, blog, members)
     *
     * category_ids - Type: string. Desc: category_ids. JSON array string
     *
     * character_count - Type: numeric. Desc: The number of characters on the post
     *
     * galleries - Type: string. Desc: will sent as array - [{ layout: 'masonry', count: 5}, { layout: 'whatever', count: 10 }]
     *
     * giphy_count - Type: numeric. Desc: count of used  giphy gifs
     *
     * image_count - Type: numeric. Desc: image_count in the post
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_edited - Type: bool. Desc: 0 - new post / 1 - edit (to know if its posted for first time)
     *
     * is_published - Type: bool. Desc: 0 - not published (draft) / 1 - published
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * original_msid - Type: guid. Desc: The msid where the post was published originally
     *
     * original_post_id - Type: string. Desc: The original post id
     *
     * paid_plan_id - Type: string. Desc: Array of paid plan ids
     *
     * post_id - Type: string. Desc: post_id
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * site_member_id - Type: guid. Desc: site member id
     *
     * used_html - Type: bool. Desc: 0 - didnt used html component / 1 - used html component
     *
     * video_count - Type: numeric. Desc: video_count in the post
     * @param {oneAppWixReadsPostPublishedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppWixReadsPostPublished = function (params) {
        return this.bi.log(__assign({ evid: 1322 }, params));
    };
    /**
    * @typedef {Object} oneAppCategoryPage3DotsClickParams
    * @property {string} category_id - category_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - category page
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: OneApp - Category page 3 dots click. Evid: 1330.
     * Event description: When the user clicks on the 3 dots button on the category page in OneApp.
    
     * category_id - Type: string. Desc: category_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: category page
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {oneAppCategoryPage3DotsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppCategoryPage3DotsClick = function (params) {
        return this.bi.log(__assign({ evid: 1330 }, params));
    };
    /**
    * @typedef {Object} shareAfterPublishModalShownParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post_id
    * @property {string} role - Role of the user - writer or admin
    **/
    /**
     * Name: Share after publish modal shown. Evid: 315.
     * Event description: Share after publish modal shown for user.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post_id
     *
     * role - Type: string. Desc: Role of the user - writer or admin
     * @param {shareAfterPublishModalShownParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.shareAfterPublishModalShown = function (params) {
        return this.bi.log(__assign({ evid: 315 }, params));
    };
    /**
    * @typedef {Object} newCategoryAddedToBlogParams
    * @property {GUID} app_id - app_id (forum, blog, members)
    * @property {number} category_count - current amount of categories i the blog
    * @property {string} category_id - category_id
    * @property {string} community_id - community_id (instance of members app)
    * @property {boolean} image - image for category was added (OneApp only)
    * @property {GUID} instance_id - instance_id
    * @property {string} language - The category language
    * @property {string} member_id - member_id
    * @property {GUID} biToken - msid
    * @property {string} label - the category name
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor, avdanced_post_settings
    * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
    * @property {string} referral_info - external links - facebook, social networks. if from wix then null
    * @property {string} role - member role (owner, writer, member)
    * @property {boolean} seo_description - category description in seo settings was added (OneApp only)
    * @property {boolean} seo_name - category name was under seo settings (OneApp only)
    * @property {string} translation_id - the Id of category that was translated
    **/
    /**
     * Name: new category added to blog. Evid: 311.
     * Event description: triggered when a new category added in the app settings.
    
     * app_id - Type: guid. Desc: app_id (forum, blog, members)
     *
     * category_count - Type: numeric. Desc: current amount of categories i the blog
     *
     * category_id - Type: string. Desc: category_id
     *
     * community_id - Type: string. Desc: community_id (instance of members app)
     *
     * image - Type: bool. Desc: image for category was added (OneApp only)
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * language - Type: string. Desc: The category language
     *
     * member_id - Type: string. Desc: member_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * label - Type: string. Desc: the category name
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor, avdanced_post_settings
     *
     * original_instance_id - Type: guid. Desc: in the members app events. holds the child app (forum/blog) instance_id
     *
     * referral_info - Type: string. Desc: external links - facebook, social networks. if from wix then null
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * seo_description - Type: bool. Desc: category description in seo settings was added (OneApp only)
     *
     * seo_name - Type: bool. Desc: category name was under seo settings (OneApp only)
     *
     * translation_id - Type: string. Desc: the Id of category that was translated
     * @param {newCategoryAddedToBlogParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.newCategoryAddedToBlog = function (params) {
        return this.bi.log(__assign({ evid: 311 }, params));
    };
    /**
    * @typedef {Object} postSettingsChangesSidebarParams
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_published - Is post published (1-published)
    * @property {string} language - the post language
    * @property {GUID} bi_token - MSID
    * @property {GUID} biToken - null
    * @property {string} post_id - post_id
    * @property {GUID} post_stable_id - post stable id
    * @property {string} property - The changed property (excerpt, author etc..)
    * @property {string} property_value - The value of the changed property
    * @property {string} role - Role of user - writer or admin
    * @property {string} tab_name - SEO, Settings, Categories
    * @property {string} translation_id - translation id
    **/
    /**
     * Name: Post settings changes - sidebar. Evid: 345.
     * Event description: This event tracks all post settings changes made by the user. For each property changed one event is emitted..
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_published - Type: bool. Desc: Is post published (1-published)
     *
     * language - Type: string. Desc: the post language
     *
     * bi_token - Type: guid. Desc: MSID
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post_id
     *
     * post_stable_id - Type: guid. Desc: post stable id
     *
     * property - Type: string. Desc: The changed property (excerpt, author etc..)
     *
     * property_value - Type: string. Desc: The value of the changed property
     *
     * role - Type: string. Desc: Role of user - writer or admin
     *
     * tab_name - Type: string. Desc: SEO, Settings, Categories
     *
     * translation_id - Type: string. Desc: translation id
     * @param {postSettingsChangesSidebarParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postSettingsChangesSidebar = function (params) {
        return this.bi.log(__assign({ evid: 345 }, params));
    };
    /**
    * @typedef {Object} advancedPostSettingsTabOpenParams
    * @property {GUID} instance_id - instance_id
    * @property {string} language - language
    * @property {GUID} bi_token - MSID
    * @property {GUID} biToken - null
    * @property {string} platform - Where event took place - live site or business manager
    * @property {string} role - Role of the user - writer or admin
    * @property {string} tab_name - Which tab was opened in post settings
    **/
    /**
     * Name: Advanced post settings tab open. Evid: 324.
     * Event description: Tab opened in advanced post settings (default tab does not count).
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * language - Type: string. Desc: language
     *
     * bi_token - Type: guid. Desc: MSID
     *
     * biToken - Type: guid.
     *
     * platform - Type: string. Desc: Where event took place - live site or business manager
     *
     * role - Type: string. Desc: Role of the user - writer or admin
     *
     * tab_name - Type: string. Desc: Which tab was opened in post settings
     * @param {advancedPostSettingsTabOpenParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.advancedPostSettingsTabOpen = function (params) {
        return this.bi.log(__assign({ evid: 324 }, params));
    };
    /**
    * @typedef {Object} postPageWidthOfPostChangedParams
    * @property {string} buildertype - In which editor changed was made: mobile, desktop
    * @property {string} eventmeta - eventmeta
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - editor
    * @property {string} referral_info - not working: referral_info
    * @property {string} role - role
    * @property {number} width - width of post after change (not very trustful, as there are some mismatches with enabled full width)
    **/
    /**
     * Name: post page - width of post changed. Evid: 309.
     * Event description: Width of post changed in post page
    width field itself is not very trustful, as it's calculated the other way around if "full width" is enabled and we can't know if it's enabled.
    
     * buildertype - Type: string. Desc: In which editor changed was made: mobile, desktop
     *
     * eventmeta - Type: string. Desc: eventmeta
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: editor
     *
     * referral_info - Type: string. Desc: not working: referral_info
     *
     * role - Type: string. Desc: role
     *
     * width - Type: numeric. Desc: width of post after change (not very trustful, as there are some mismatches with enabled full width)
     * @param {postPageWidthOfPostChangedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postPageWidthOfPostChanged = function (params) {
        return this.bi.log(__assign({ evid: 309 }, params));
    };
    /**
    * @typedef {Object} migrationGetStartedClickParams
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_first - is it the first time the user opens this tab?
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} referral_info - referral_info
    * @property {string} role - role
    **/
    /**
     * Name: Migration -> Get started click. Evid: 381.
     * Event description: triggered when users click on get started.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_first - Type: bool. Desc: is it the first time the user opens this tab?
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * referral_info - Type: string. Desc: referral_info
     *
     * role - Type: string. Desc: role
     * @param {migrationGetStartedClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationGetStartedClick = function (params) {
        return this.bi.log(__assign({ evid: 381 }, params));
    };
    /**
    * @typedef {Object} oneAppGenericButtonClickParams
    * @property {string} button_name - the button name
    * @property {GUID} instance_id - instance
    * @property {GUID} biToken - msid
    * @property {string} origin - post page
    * @property {string} post_id - post_id
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: OneApp generic button click. Evid: 1326.
     * Event description: the user clicked on a button.
    
     * button_name - Type: string. Desc: the button name
     *
     * instance_id - Type: guid. Desc: instance
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: post page
     *
     * post_id - Type: string. Desc: post_id
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {oneAppGenericButtonClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppGenericButtonClick = function (params) {
        return this.bi.log(__assign({ evid: 1326 }, params));
    };
    /**
    * @typedef {Object} imageSettingsPanelInPostEditorOpenedParams
    * @property {GUID} app_id - app_id (forum, blog, members)
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_published - 0 - not published (draft) / 1 - published
    * @property {string} member_id - member_id
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} post_id - post_id
    * @property {string} role - member role (owner, writer, member)
    * @property {GUID} site_member_id - site_member_id
    **/
    /**
     * Name: image settings panel in post editor opened. Evid: 362.
     * Event description: image settings panel in post editor opened.
    
     * app_id - Type: guid. Desc: app_id (forum, blog, members)
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_published - Type: bool. Desc: 0 - not published (draft) / 1 - published
     *
     * member_id - Type: string. Desc: member_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * post_id - Type: string. Desc: post_id
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * site_member_id - Type: guid. Desc: site_member_id
     * @param {imageSettingsPanelInPostEditorOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.imageSettingsPanelInPostEditorOpened = function (params) {
        return this.bi.log(__assign({ evid: 362 }, params));
    };
    /**
    * @typedef {Object} oneAppSharePostCopyUrlClickParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - msid
    * @property {string} origin - after publish
    * @property {string} post_id - post_id
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: OneApp share post (copy url) click. Evid: 1314.
     * Event description: user copied url to clipboard (clicked share post).
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: after publish
     *
     * post_id - Type: string. Desc: post_id
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {oneAppSharePostCopyUrlClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppSharePostCopyUrlClick = function (params) {
        return this.bi.log(__assign({ evid: 1314 }, params));
    };
    /**
    * @typedef {Object} oldBlogGfppClickParams
    * @property {GUID} instance_id - null
    * @property {boolean} is_mobile - TRUE if it's mobile editor
    * @property {GUID} biToken - null
    * @property {string} name - gfpp name - Update, Manage Blog, Help
    * @property {string} widget_app - the name of widget/app - Blog Feed Single Post Page Featured Post Posts Lists Custom Feed Ticker Posts Gallery Tag Cloud Categories Archive
    **/
    /**
     * Name: Magic Migration: Old Blog GFPP click. Evid: 404.
     * Event description: Click on old blog gfpp.
    
     * instance_id - Type: guid.
     *
     * is_mobile - Type: bool. Desc: TRUE if it's mobile editor
     *
     * biToken - Type: guid.
     *
     * name - Type: string. Desc: gfpp name - Update, Manage Blog, Help
     *
     * widget_app - Type: string. Desc: the name of widget/app - Blog Feed Single Post Page Featured Post Posts Lists Custom Feed Ticker Posts Gallery Tag Cloud Categories Archive
     * @param {oldBlogGfppClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oldBlogGfppClick = function (params) {
        return this.bi.log(__assign({ evid: 404 }, params));
    };
    /**
    * @typedef {Object} draftSavedParams
    * @property {number} character_count - Character count in post
    * @property {GUID} instance_id - null
    * @property {boolean} is_offline - if the event happened offline
    * @property {string} language - for multilingual
    * @property {GUID} biToken - null
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} post_id - post_id
    * @property {GUID} post_stable_id - post stable id
    * @property {string} post_title - post title
    * @property {string} role - member role (owner, writer, member)
    * @property {string} translation_id - the post_stable_id of the post that was translated
    **/
    /**
     * Name: Draft saved (Web, BO). Evid: 313.
     * Event description: triggered when a post draft is saved each time (Web Only).
    
     * character_count - Type: numeric. Desc: Character count in post
     *
     * instance_id - Type: guid.
     *
     * is_offline - Type: bool. Desc: if the event happened offline
     *
     * language - Type: string. Desc: for multilingual
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * post_id - Type: string. Desc: post_id
     *
     * post_stable_id - Type: guid. Desc: post stable id
     *
     * post_title - Type: string. Desc: post title
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * translation_id - Type: string. Desc: the post_stable_id of the post that was translated
     * @param {draftSavedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.draftSaved = function (params) {
        return this.bi.log(__assign({ evid: 313 }, params));
    };
    /**
    * @typedef {Object} blogSettingsEditSeoBlogTagsClickParams
    * @property {GUID} instance_id - instance
    * @property {GUID} biToken - msid
    * @property {string} origin - origin
    * @property {string} referrer - referrer
    * @property {string} role - role
    **/
    /**
     * Name: Blog settings - Edit SEO Blog Tags click  (to be deleted). Evid: 371.
     * Event description: triggered when the user clicks on the edit button on the Blog settings screen, under the SEO settings section..
    
     * instance_id - Type: guid. Desc: instance
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin
     *
     * referrer - Type: string. Desc: referrer
     *
     * role - Type: string. Desc: role
     * @param {blogSettingsEditSeoBlogTagsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.blogSettingsEditSeoBlogTagsClick = function (params) {
        return this.bi.log(__assign({ evid: 371 }, params));
    };
    /**
    * @typedef {Object} blogLoadedInEditorParams
    * @property {string} blog_view - Blog Feed or Post Page
    * @property {string} editor_view_mode - Computer/Mobile
    * @property {GUID} instance_id - null
    * @property {boolean} isPreview - Is it in Preview mode (if not, it's Editor)
    * @property {GUID} biToken - null
    * @property {string} role - role
    **/
    /**
     * Name: Blog loaded in Editor. Evid: 399.
     * Event description: Once blog app loaded in Editor, used for AB test exposure. NOTE: When the Page post is selected and whenever the user switches the view, the event gets triggered 2 times one with Blog feed and another with Post view..
    
     * blog_view - Type: string. Desc: Blog Feed or Post Page
     *
     * editor_view_mode - Type: string. Desc: Computer/Mobile
     *
     * instance_id - Type: guid.
     *
     * isPreview - Type: bool. Desc: Is it in Preview mode (if not, it's Editor)
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: role
     * @param {blogLoadedInEditorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.blogLoadedInEditor = function (params) {
        return this.bi.log(__assign({ evid: 399 }, params));
    };
    /**
    * @typedef {Object} postPagePostPageOpenedParams
    * @property {string} app_id - app_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - blog_feed, page_preview
    * @property {string} referrer - The place from which this was opened
    * @property {string} role - role
    **/
    /**
     * Name: post page - post page opened. Evid: 350.
     * Event description: Post page opened in editor.
    
     * app_id - Type: string. Desc: app_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: blog_feed, page_preview
     *
     * referrer - Type: string. Desc: The place from which this was opened
     *
     * role - Type: string. Desc: role
     * @param {postPagePostPageOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postPagePostPageOpened = function (params) {
        return this.bi.log(__assign({ evid: 350 }, params));
    };
    /**
    * @typedef {Object} oneAppManageCategoriesEditCategoryOpenedParams
    * @property {string} category_id - category_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - Where tabs was opened (Manage)
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: OneApp Manage Categories edit category opened. Evid: 1313.
     * Event description: Clicked on add new category button in OneApp.
    
     * category_id - Type: string. Desc: category_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: Where tabs was opened (Manage)
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {oneAppManageCategoriesEditCategoryOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppManageCategoriesEditCategoryOpened = function (params) {
        return this.bi.log(__assign({ evid: 1313 }, params));
    };
    /**
    * @typedef {Object} blog6thButtonWasOpenedParams
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_first_time_view - 1 - onboarding view 0 -blog manager
    * @property {GUID} biToken - msid
    * @property {string} origin - 6th button or Add panel
    **/
    /**
     * Name: blog 6th button - was opened. Evid: 320.
     * Event description: triggered when 6th button content is opened in the 6th button or the Add panel in the editor.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_first_time_view - Type: bool. Desc: 1 - onboarding view 0 -blog manager
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: 6th button or Add panel
     * @param {blog6thButtonWasOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.blog6thButtonWasOpened = function (params) {
        return this.bi.log(__assign({ evid: 320 }, params));
    };
    /**
    * @typedef {Object} oneAppEditCategoryParams
    * @property {string} category_description - category description
    * @property {string} category_id - category id
    * @property {string} category_image - category image
    * @property {string} category_name - category label
    * @property {string} categoryTitle - category title
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - from where did the user get to this screen
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: OneApp - Edit Category. Evid: 1333.
     * Event description: User edited a category.
    
     * category_description - Type: string. Desc: category description
     *
     * category_id - Type: string. Desc: category id
     *
     * category_image - Type: string. Desc: category image
     *
     * category_name - Type: string. Desc: category label
     *
     * categoryTitle - Type: string. Desc: category title
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: from where did the user get to this screen
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {oneAppEditCategoryParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppEditCategory = function (params) {
        return this.bi.log(__assign({ evid: 1333 }, params));
    };
    /**
    * @typedef {Object} editorSettingsOpenedParams
    * @property {string} app_id - app_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - post_page, blog_feed
    * @property {string} referrer - from which place it was opened
    * @property {string} role - role
    **/
    /**
     * Name: editor settings opened. Evid: 351.
     * Event description: Settings opened.
    
     * app_id - Type: string. Desc: app_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: post_page, blog_feed
     *
     * referrer - Type: string. Desc: from which place it was opened
     *
     * role - Type: string. Desc: role
     * @param {editorSettingsOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.editorSettingsOpened = function (params) {
        return this.bi.log(__assign({ evid: 351 }, params));
    };
    /**
    * @typedef {Object} bm3DotsClick341Params
    * @property {GUID} instance_id - instance
    * @property {GUID} biToken - msid
    * @property {string} origin - origin
    * @property {string} role - role
    **/
    /**
     * Name: BM 3 dots / More Actions click. Evid: 341.
     * Event description: Triggered when the user clicks on the 3 dots menu.
    
     * instance_id - Type: guid. Desc: instance
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin
     *
     * role - Type: string. Desc: role
     * @param {bm3DotsClick341Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bm3DotsClick341 = function (params) {
        return this.bi.log(__assign({ evid: 341 }, params));
    };
    /**
    * @typedef {Object} addBlogAppDisplayTypeOfBlogModalParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Add blog app - show members area modal (with options to install). Evid: 329.
     * Event description: Whenever the user adds the blog app to a site. This event records if the type of blog modal was displayed..
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {addBlogAppDisplayTypeOfBlogModalParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.addBlogAppDisplayTypeOfBlogModal = function (params) {
        return this.bi.log(__assign({ evid: 329 }, params));
    };
    /**
    * @typedef {Object} editorSettingsDesignTabParams
    * @property {string} app_id - app_id
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - msid
    * @property {string} origin - Post Page Settings, app settings (feed)
    * @property {string} property - The property changed e.g. playback speed,
    * @property {string} property_value - the setting value. eg. True,
    * @property {string} role - role
    * @property {string} section - The section where the changes occurred, i.e. Blog Menu, Posts, Buttons
    * @property {boolean} toggle - Deprecate
    **/
    /**
     * Name: editor - settings design tab. Evid: 356.
     * Event description: Actions on tab inside settings.
    
     * app_id - Type: string. Desc: app_id
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: Post Page Settings, app settings (feed)
     *
     * property - Type: string. Desc: The property changed e.g. playback speed,
     *
     * property_value - Type: string. Desc: the setting value. eg. True,
     *
     * role - Type: string. Desc: role
     *
     * section - Type: string. Desc: The section where the changes occurred, i.e. Blog Menu, Posts, Buttons
     *
     * toggle - Type: bool. Desc: Deprecate
     * @param {editorSettingsDesignTabParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.editorSettingsDesignTab = function (params) {
        return this.bi.log(__assign({ evid: 356 }, params));
    };
    /**
    * @typedef {Object} oneAppBlogPageSettingsScreenOpenedParams
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - from where did the user get to this screen
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: OneApp - Blog Page settings screen opened. Evid: 1331.
     * Event description: User opens the blog Page screen settings.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: from where did the user get to this screen
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {oneAppBlogPageSettingsScreenOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppBlogPageSettingsScreenOpened = function (params) {
        return this.bi.log(__assign({ evid: 1331 }, params));
    };
    /**
    * @typedef {Object} postEditorAddMediaElementClickParams
    * @property {GUID} instance_id - instance_id
    * @property {GUID} bi_token - MSID
    * @property {GUID} biToken - null
    * @property {string} origin - sidebar or text area
    * @property {string} role - Role of the user - writer or admin
    * @property {string} tab_name - Which tab was opened in post settings
    **/
    /**
     * Name: Post Editor - Add Media Element Click. Evid: 378.
     * Event description: When the user clicks the "+" in the post editor (sidebar or text area).
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * bi_token - Type: guid. Desc: MSID
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: sidebar or text area
     *
     * role - Type: string. Desc: Role of the user - writer or admin
     *
     * tab_name - Type: string. Desc: Which tab was opened in post settings
     * @param {postEditorAddMediaElementClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postEditorAddMediaElementClick = function (params) {
        return this.bi.log(__assign({ evid: 378 }, params));
    };
    /**
    * @typedef {Object} clickOnTooltipParams
    * @property {string} click_name - click name
    * @property {GUID} instance_id - instance
    * @property {GUID} biToken - msid
    * @property {string} origin - origin
    * @property {string} role - role
    * @property {string} text - the tooltip text
    * @property {string} tooltip_name - tooltip name
    **/
    /**
     * Name: click on tooltip. Evid: 414.
     * Event description: Fired when the user clicks a link inside a tooltip.
    
     * click_name - Type: string. Desc: click name
     *
     * instance_id - Type: guid. Desc: instance
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin
     *
     * role - Type: string. Desc: role
     *
     * text - Type: string. Desc: the tooltip text
     *
     * tooltip_name - Type: string. Desc: tooltip name
     * @param {clickOnTooltipParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnTooltip = function (params) {
        return this.bi.log(__assign({ evid: 414 }, params));
    };
    /**
    * @typedef {Object} oneAppManageFilterPostsClickParams
    * @property {string} filter - Which filter in Wix App is used: Analytics/posts/drafts
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - msid
    * @property {string} origin - Where tabs was opened (Manage)
    * @property {string} role - member role (owner, writer, member)
    * @property {string} tab_name - Published/Dratfs
    **/
    /**
     * Name: OneApp Manage filter posts click. Evid: 1305.
     * Event description: Click on filter post in OneApp (to choose your own or written by others posts).
    
     * filter - Type: string. Desc: Which filter in Wix App is used: Analytics/posts/drafts
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: Where tabs was opened (Manage)
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * tab_name - Type: string. Desc: Published/Dratfs
     * @param {oneAppManageFilterPostsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppManageFilterPostsClick = function (params) {
        return this.bi.log(__assign({ evid: 1305 }, params));
    };
    /**
    * @typedef {Object} advancedPostSettingsOpenParams
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_published - Is post published (1-published)
    * @property {GUID} biToken - MSID
    * @property {string} platform - Was opened in back office/live site
    * @property {string} role - Role of the user - writer or admin
    **/
    /**
     * Name: Advanced post settings open. Evid: 328.
     * Event description: Advanced post settings opened.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_published - Type: bool. Desc: Is post published (1-published)
     *
     * biToken - Type: guid. Desc: MSID
     *
     * platform - Type: string. Desc: Was opened in back office/live site
     *
     * role - Type: string. Desc: Role of the user - writer or admin
     * @param {advancedPostSettingsOpenParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.advancedPostSettingsOpen = function (params) {
        return this.bi.log(__assign({ evid: 328 }, params));
    };
    /**
    * @typedef {Object} oneAppModalOptionClickParams
    * @property {string} action_name - the option the user clicked / selected on the modal
    * @property {GUID} instance_id - instance
    * @property {string} modal_name - modal name
    * @property {GUID} biToken - msid
    * @property {string} origin - origin - the previous screen/modal
    * @property {string} role - role
    * @property {GUID} visitor_id - visitor
    **/
    /**
     * Name: OneApp - Modal option click. Evid: 1321.
     * Event description: Generic event to track clicks within a modal in OneApp.
    
     * action_name - Type: string. Desc: the option the user clicked / selected on the modal
     *
     * instance_id - Type: guid. Desc: instance
     *
     * modal_name - Type: string. Desc: modal name
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin - the previous screen/modal
     *
     * role - Type: string. Desc: role
     *
     * visitor_id - Type: guid. Desc: visitor
     * @param {oneAppModalOptionClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppModalOptionClick = function (params) {
        return this.bi.log(__assign({ evid: 1321 }, params));
    };
    /**
    * @typedef {Object} helperShowedParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} name - name of helper
    **/
    /**
     * Name: helper_showed. Evid: 363.
     * Event description: Helper was showed (for custom feed confusion currently, can be reused later for others if needed).
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * name - Type: string. Desc: name of helper
     * @param {helperShowedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.helperShowed = function (params) {
        return this.bi.log(__assign({ evid: 363 }, params));
    };
    /**
    * @typedef {Object} oneappBlogSearchTextEnteredParams
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - Where tabs was opened (Manage)
    * @property {string} role - member role (owner, writer, member)
    * @property {string} tab_name - Posts, Categories, Authors, Tags
    * @property {string} text - Text entered in a search
    **/
    /**
     * Name: Oneapp - Blog search text entered. Evid: 1336.
     * Event description: After text was entered in search.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: Where tabs was opened (Manage)
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * tab_name - Type: string. Desc: Posts, Categories, Authors, Tags
     *
     * text - Type: string. Desc: Text entered in a search
     * @param {oneappBlogSearchTextEnteredParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneappBlogSearchTextEntered = function (params) {
        return this.bi.log(__assign({ evid: 1336 }, params));
    };
    /**
    * @typedef {Object} postScheduledParams
    * @property {GUID} app_id - app_id (forum, blog, members)
    * @property {string} category_ids - category_ids. JSON array string
    * @property {number} character_count - The number of characters on the post
    * @property {string} galleries - will sent as array - [{ layout: 'masonry', count: 5}, { layout: 'whatever', count: 10 }]
    * @property {number} giphy_count - count of used  giphy gifs
    * @property {number} image_count - image_count in the post
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_edited - 0 - new post / 1 - edit (to know if its posted for first time)
    * @property {boolean} is_rescheduled - TRUE if rescheduled
    * @property {string} member_id - NOT USED: member_id
    * @property {GUID} biToken - null
    * @property {number} offset - the user timezone offset relative to UTC (in minutes)
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} post_id - post_id
    * @property {string} role - member role (owner, writer, member)
    * @property {DateTime} scheduled_date - The date when the post must be published (UTC)
    * @property {boolean} used_html - 0 - didnt used html component / 1 - used html component
    * @property {number} video_count - video_count in the post
    **/
    /**
     * Name: post scheduled. Evid: 336.
     * Event description: triggered when a post is scheduled..
    
     * app_id - Type: guid. Desc: app_id (forum, blog, members)
     *
     * category_ids - Type: string. Desc: category_ids. JSON array string
     *
     * character_count - Type: numeric. Desc: The number of characters on the post
     *
     * galleries - Type: string. Desc: will sent as array - [{ layout: 'masonry', count: 5}, { layout: 'whatever', count: 10 }]
     *
     * giphy_count - Type: numeric. Desc: count of used  giphy gifs
     *
     * image_count - Type: numeric. Desc: image_count in the post
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_edited - Type: bool. Desc: 0 - new post / 1 - edit (to know if its posted for first time)
     *
     * is_rescheduled - Type: bool. Desc: TRUE if rescheduled
     *
     * member_id - Type: string. Desc: NOT USED: member_id
     *
     * biToken - Type: guid.
     *
     * offset - Type: numeric. Desc: the user timezone offset relative to UTC (in minutes)
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * post_id - Type: string. Desc: post_id
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * scheduled_date - Type: datetime. Desc: The date when the post must be published (UTC)
     *
     * used_html - Type: bool. Desc: 0 - didnt used html component / 1 - used html component
     *
     * video_count - Type: numeric. Desc: video_count in the post
     * @param {postScheduledParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postScheduled = function (params) {
        return this.bi.log(__assign({ evid: 336 }, params));
    };
    /**
    * @typedef {Object} blog6thButtonOnBoardingScreenClickParams
    * @property {string} button_name - 'find out more' or 'add now'
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_first_time_view - 1 - onboarding view 0 -blog manager
    * @property {GUID} biToken - msid
    * @property {string} origin - 6th button or Add panel
    **/
    /**
     * Name: blog 6th button - On boarding screen click. Evid: 321.
     * Event description: triggered when clicking inside the blog 6th button.
    
     * button_name - Type: string. Desc: 'find out more' or 'add now'
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_first_time_view - Type: bool. Desc: 1 - onboarding view 0 -blog manager
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: 6th button or Add panel
     * @param {blog6thButtonOnBoardingScreenClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.blog6thButtonOnBoardingScreenClick = function (params) {
        return this.bi.log(__assign({ evid: 321 }, params));
    };
    /**
    * @typedef {Object} multilingualHoverTranslateGlobeParams
    * @property {GUID} app_id - app_id (forum, blog, members)
    * @property {string} community_id - community_id (instance of members app)
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} role - member role (owner, writer, member)
    * @property {GUID} site_member_id - site_member_id
    * @property {string} tabName - tab name: published, drafts, trash,  categories
    **/
    /**
     * Name: Multilingual - hover translate globe. Evid: 418.
     * Event description: triggered when user hovers on the translate globe..
    
     * app_id - Type: guid. Desc: app_id (forum, blog, members)
     *
     * community_id - Type: string. Desc: community_id (instance of members app)
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * tabName - Type: string. Desc: tab name: published, drafts, trash,  categories
     * @param {multilingualHoverTranslateGlobeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.multilingualHoverTranslateGlobe = function (params) {
        return this.bi.log(__assign({ evid: 418 }, params));
    };
    /**
    * @typedef {Object} postPageMigrationModalOpenedParams
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} role - role
    **/
    /**
     * Name: Post page Migration  modal opened. Evid: 354.
     * Event description: triggered when Migration post page modal was opened (modal where user can click a button to migrate).
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * role - Type: string. Desc: role
     * @param {postPageMigrationModalOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postPageMigrationModalOpened = function (params) {
        return this.bi.log(__assign({ evid: 354 }, params));
    };
    /**
    * @typedef {Object} postsBm3DotsParams
    * @property {string} action - view post, duplicate post, revert to draft, turn off commenting, move to trash, preview draft, duplicate draft
    * @property {GUID} instance_id - null
    * @property {string} language - the language ML
    * @property {string} language_id - the post_ stable id of the original post
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    * @property {GUID} post_stable_id - post stable id
    * @property {string} tabName - Posts or Drafts
    **/
    /**
     * Name: Posts BM 3 dots - option clicked. Evid: 331.
     * Event description: Whenever a user clicks one of the options from the 3 dots menu, in the Business Manager.
    
     * action - Type: string. Desc: view post, duplicate post, revert to draft, turn off commenting, move to trash, preview draft, duplicate draft
     *
     * instance_id - Type: guid.
     *
     * language - Type: string. Desc: the language ML
     *
     * language_id - Type: string. Desc: the post_ stable id of the original post
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     *
     * post_stable_id - Type: guid. Desc: post stable id
     *
     * tabName - Type: string. Desc: Posts or Drafts
     * @param {postsBm3DotsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postsBm3Dots = function (params) {
        return this.bi.log(__assign({ evid: 331 }, params));
    };
    /**
    * @typedef {Object} oneAppConnectPlanToPostParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} paid_plan_id - Array paid plan Ids
    * @property {string} post_ids - Array of posts
    * @property {string} role - role
    **/
    /**
     * Name: OneApp - connect plan to post. Evid: 1325.
     * Event description: triggered in OneApp when the user connects a plan to a post(s).
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * paid_plan_id - Type: string. Desc: Array paid plan Ids
     *
     * post_ids - Type: string. Desc: Array of posts
     *
     * role - Type: string. Desc: role
     * @param {oneAppConnectPlanToPostParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppConnectPlanToPost = function (params) {
        return this.bi.log(__assign({ evid: 1325 }, params));
    };
    /**
    * @typedef {Object} migrationCopiedSuccessModalOpenedParams
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_first - is it the first time the user opens this tab?
    * @property {string} migration_status - First time, In progress, Done (after finishing migration)
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} referral_info - referral_info
    * @property {string} role - role
    **/
    /**
     * Name: Migration -> Copied success modal opened. Evid: 386.
     * Event description: triggered when Migration Copied success modal opened actually open.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_first - Type: bool. Desc: is it the first time the user opens this tab?
     *
     * migration_status - Type: string. Desc: First time, In progress, Done (after finishing migration)
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * referral_info - Type: string. Desc: referral_info
     *
     * role - Type: string. Desc: role
     * @param {migrationCopiedSuccessModalOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationCopiedSuccessModalOpened = function (params) {
        return this.bi.log(__assign({ evid: 386 }, params));
    };
    /**
    * @typedef {Object} actionChoseInBmMoreActionsMenuParams
    * @property {string} actionName - Action name chose inside menu
    * @property {GUID} instance_id - instance
    * @property {GUID} biToken - msid
    * @property {string} origin - origin
    * @property {string} role - role
    **/
    /**
     * Name: Action chose in BM  More Actions menu. Evid: 344.
     * Event description: Triggered when the user clicks action under more actions menu in blog BO. For click on More actions itself, see event 69:341.
    
     * actionName - Type: string. Desc: Action name chose inside menu
     *
     * instance_id - Type: guid. Desc: instance
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin
     *
     * role - Type: string. Desc: role
     * @param {actionChoseInBmMoreActionsMenuParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.actionChoseInBmMoreActionsMenu = function (params) {
        return this.bi.log(__assign({ evid: 344 }, params));
    };
    /**
    * @typedef {Object} writeNewPostClickParams
    * @property {GUID} app_id - app_id (forum, blog, members)
    * @property {string} community_id - community_id (instance of members app)
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_offline - if the event happened offline
    * @property {string} language - for multilingual
    * @property {string} member_id - member_id
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
    * @property {string} referral_info - external links - facebook, social networks. if from wix then null
    * @property {string} role - member role (owner, writer, member)
    * @property {GUID} site_member_id - site_member_id
    **/
    /**
     * Name: write new post click. Evid: 308.
     * Event description: triggered when click on write new post CTA.
    
     * app_id - Type: guid. Desc: app_id (forum, blog, members)
     *
     * community_id - Type: string. Desc: community_id (instance of members app)
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_offline - Type: bool. Desc: if the event happened offline
     *
     * language - Type: string. Desc: for multilingual
     *
     * member_id - Type: string. Desc: member_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * original_instance_id - Type: guid. Desc: in the members app events. holds the child app (forum/blog) instance_id
     *
     * referral_info - Type: string. Desc: external links - facebook, social networks. if from wix then null
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * site_member_id - Type: guid. Desc: site_member_id
     * @param {writeNewPostClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.writeNewPostClick = function (params) {
        return this.bi.log(__assign({ evid: 308 }, params));
    };
    /**
    * @typedef {Object} blogManagerOpenedBoParams
    * @property {GUID} app_id - app_id (forum, blog, members)
    * @property {string} community_id - community_id (instance of members app)
    * @property {GUID} instance_id - instance_id
    * @property {string} language - the language if ML
    * @property {string} member_id - member_id
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
    * @property {string} referral_info - external links - facebook, social networks. if from wix then null
    * @property {string} referrer - the place from which it was open
    * @property {string} role - member role (owner, writer, member)
    * @property {GUID} site_member_id - site_member_id
    **/
    /**
     * Name: blog manager opened (BO). Evid: 301.
     * Event description: triggered when blog manager actually open!.
    
     * app_id - Type: guid. Desc: app_id (forum, blog, members)
     *
     * community_id - Type: string. Desc: community_id (instance of members app)
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * language - Type: string. Desc: the language if ML
     *
     * member_id - Type: string. Desc: member_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * original_instance_id - Type: guid. Desc: in the members app events. holds the child app (forum/blog) instance_id
     *
     * referral_info - Type: string. Desc: external links - facebook, social networks. if from wix then null
     *
     * referrer - Type: string. Desc: the place from which it was open
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * site_member_id - Type: guid. Desc: site_member_id
     * @param {blogManagerOpenedBoParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.blogManagerOpenedBo = function (params) {
        return this.bi.log(__assign({ evid: 301 }, params));
    };
    /**
    * @typedef {Object} editorSettingsTabOpenedParams
    * @property {string} app_id - app_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - Place settings was changed in: blog_feed, post_page
    * @property {string} referrer - from which place it was opened
    * @property {string} role - role
    * @property {string} tab_name - tab name inside post settings
    **/
    /**
     * Name: editor - settings tab opened. Evid: 352.
     * Event description: Tab inside settings opened.
    
     * app_id - Type: string. Desc: app_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: Place settings was changed in: blog_feed, post_page
     *
     * referrer - Type: string. Desc: from which place it was opened
     *
     * role - Type: string. Desc: role
     *
     * tab_name - Type: string. Desc: tab name inside post settings
     * @param {editorSettingsTabOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.editorSettingsTabOpened = function (params) {
        return this.bi.log(__assign({ evid: 352 }, params));
    };
    /**
    * @typedef {Object} editorCustomizeLayoutButtonClickParams
    * @property {GUID} instance_id - instance
    * @property {string} layout - the selected layout
    * @property {GUID} biToken - msid
    * @property {string} origin - post list, blog feed
    * @property {string} post_id - post_id
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: Editor - Customize Layout button click. Evid: 420.
     * Event description: User clicked customize layout from the while editing the blog or post feed.
    
     * instance_id - Type: guid. Desc: instance
     *
     * layout - Type: string. Desc: the selected layout
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: post list, blog feed
     *
     * post_id - Type: string. Desc: post_id
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {editorCustomizeLayoutButtonClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.editorCustomizeLayoutButtonClick = function (params) {
        return this.bi.log(__assign({ evid: 420 }, params));
    };
    /**
    * @typedef {Object} adiBlogSettingsToggleClickParams
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_enabled - 1 - enabled, 0 - disabled
    * @property {GUID} bi_token - MSID
    * @property {GUID} biToken - null
    * @property {string} role - Role of user - writer or admin
    * @property {string} toggle_name - Name of the toggle in blog settings
    **/
    /**
     * Name: ADI Blog settings toggle click. Evid: 327.
     * Event description: Which settings user chose on Settings panel in ADI.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_enabled - Type: bool. Desc: 1 - enabled, 0 - disabled
     *
     * bi_token - Type: guid. Desc: MSID
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: Role of user - writer or admin
     *
     * toggle_name - Type: string. Desc: Name of the toggle in blog settings
     * @param {adiBlogSettingsToggleClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.adiBlogSettingsToggleClick = function (params) {
        return this.bi.log(__assign({ evid: 327 }, params));
    };
    /**
    * @typedef {Object} tagCreatedParams
    * @property {GUID} instance_id - null
    * @property {string} language - language
    * @property {GUID} biToken - null
    * @property {string} origin - origin
    * @property {string} role - role
    * @property {GUID} tag_guid - tag stable id
    * @property {string} tagid - tag_id
    * @property {string} tag_name - tag label
    * @property {string} translation_id - translation_id
    **/
    /**
     * Name: Tag Created. Evid: 314.
     * Event description: triggered whenever the user removes a tag from the post..
    
     * instance_id - Type: guid.
     *
     * language - Type: string. Desc: language
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: origin
     *
     * role - Type: string. Desc: role
     *
     * tag_guid - Type: guid. Desc: tag stable id
     *
     * tagid - Type: string. Desc: tag_id
     *
     * tag_name - Type: string. Desc: tag label
     *
     * translation_id - Type: string. Desc: translation_id
     * @param {tagCreatedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.tagCreated = function (params) {
        return this.bi.log(__assign({ evid: 314 }, params));
    };
    /**
    * @typedef {Object} oneAppManageFilterPostsSaveClickParams
    * @property {string} filter - Which filter in Wix App is used: Analytics/posts/drafts
    * @property {string} filter_name - "My Posts"/"Posts by Others"/"All Posts"
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - msid
    * @property {string} origin - Where tabs was opened (Manage)
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: OneApp Manage filter posts save click. Evid: 1306.
     * Event description: Click on filter post in OneApp (to choose your own or written by others posts).
    
     * filter - Type: string. Desc: Which filter in Wix App is used: Analytics/posts/drafts
     *
     * filter_name - Type: string. Desc: "My Posts"/"Posts by Others"/"All Posts"
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: Where tabs was opened (Manage)
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {oneAppManageFilterPostsSaveClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppManageFilterPostsSaveClick = function (params) {
        return this.bi.log(__assign({ evid: 1306 }, params));
    };
    /**
    * @typedef {Object} oneAppBlogPageSettingsChangedParams
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - from where did the user get to this screen
    * @property {string} property - property
    * @property {string} property_value - property value
    * @property {string} role - member role (owner, writer, member)
    * @property {string} tab_name - Post or Category
    **/
    /**
     * Name: OneApp - Blog Page settings changed. Evid: 1332.
     * Event description: User opens the blog Page screen settings.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: from where did the user get to this screen
     *
     * property - Type: string. Desc: property
     *
     * property_value - Type: string. Desc: property value
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * tab_name - Type: string. Desc: Post or Category
     * @param {oneAppBlogPageSettingsChangedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppBlogPageSettingsChanged = function (params) {
        return this.bi.log(__assign({ evid: 1332 }, params));
    };
    /**
    * @typedef {Object} dotsClickPostEditorParams
    * @property {GUID} instance_id - instance
    * @property {boolean} is_published - Is post published
    * @property {GUID} biToken - null
    * @property {string} origin - origin
    * @property {string} post_id - post id
    * @property {string} role - role
    **/
    /**
     * Name: 3 dots click - post editor. Evid: 339.
     * Event description: Triggered when the user clicks on the 3 dots menu that sits next to the publish button, within the Post Editor.
    
     * instance_id - Type: guid. Desc: instance
     *
     * is_published - Type: bool. Desc: Is post published
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: origin
     *
     * post_id - Type: string. Desc: post id
     *
     * role - Type: string. Desc: role
     * @param {dotsClickPostEditorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dotsClickPostEditor = function (params) {
        return this.bi.log(__assign({ evid: 339 }, params));
    };
    /**
    * @typedef {Object} postEditorOpenedParams
    * @property {GUID} app_id - app_id (forum, blog, members)
    * @property {number} character_count - character count in post (sends only on Web)
    * @property {string} community_id - NOT IN USE: community_id (instance of members app)
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_offline - if the event happened offline
    * @property {boolean} is_published - 0 - not published (draft) / 1 - published
    * @property {string} language - to be used in multilingual context.
    * @property {string} member_id - member_id
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {GUID} original_instance_id - NOT IN USE: in the members app events. holds the child app (forum/blog) instance_id
    * @property {string} post_id - post_id
    * @property {GUID} post_stable_id - stable id
    * @property {string} post_title - post title
    * @property {string} referral_info - NOT IN USE: external links - facebook, social networks. if from wix then null
    * @property {string} referrer - the place from which it was opened
    * @property {string} role - member role (owner, writer, member)
    * @property {GUID} site_member_id - site_member_id
    * @property {string} translatation_id - the post_stable_id of the translated post
    **/
    /**
     * Name: post editor opened. Evid: 307.
     * Event description: triggered when post editor opened.
    
     * app_id - Type: guid. Desc: app_id (forum, blog, members)
     *
     * character_count - Type: numeric. Desc: character count in post (sends only on Web)
     *
     * community_id - Type: string. Desc: NOT IN USE: community_id (instance of members app)
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_offline - Type: bool. Desc: if the event happened offline
     *
     * is_published - Type: bool. Desc: 0 - not published (draft) / 1 - published
     *
     * language - Type: string. Desc: to be used in multilingual context.
     *
     * member_id - Type: string. Desc: member_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * original_instance_id - Type: guid. Desc: NOT IN USE: in the members app events. holds the child app (forum/blog) instance_id
     *
     * post_id - Type: string. Desc: post_id
     *
     * post_stable_id - Type: guid. Desc: stable id
     *
     * post_title - Type: string. Desc: post title
     *
     * referral_info - Type: string. Desc: NOT IN USE: external links - facebook, social networks. if from wix then null
     *
     * referrer - Type: string. Desc: the place from which it was opened
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * translatation_id - Type: string. Desc: the post_stable_id of the translated post
     * @param {postEditorOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postEditorOpened = function (params) {
        return this.bi.log(__assign({ evid: 307 }, params));
    };
    /**
    * @typedef {Object} oneAppManageCategoriesThreeDotsClickParams
    * @property {string} category_id - category_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - Where tabs was opened (Manage)
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: OneApp Manage Categories three dots click. Evid: 1310.
     * Event description: Number of posts found in search in OneApp Manage.
    
     * category_id - Type: string. Desc: category_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: Where tabs was opened (Manage)
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {oneAppManageCategoriesThreeDotsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppManageCategoriesThreeDotsClick = function (params) {
        return this.bi.log(__assign({ evid: 1310 }, params));
    };
    /**
    * @typedef {Object} multilingualLanguagePickerOpenParams
    * @property {GUID} instance_id - instance id
    * @property {boolean} isFilter - is the language picker a filter?
    * @property {GUID} biToken - instance id
    * @property {string} origin - origin
    * @property {string} role - role
    * @property {string} tabName - tab name
    **/
    /**
     * Name: Multilingual - language picker open. Evid: 415.
     * Event description: Triggered when the user clicks and opens on the language picker.
    
     * instance_id - Type: guid. Desc: instance id
     *
     * isFilter - Type: bool. Desc: is the language picker a filter?
     *
     * biToken - Type: guid. Desc: instance id
     *
     * origin - Type: string. Desc: origin
     *
     * role - Type: string. Desc: role
     *
     * tabName - Type: string. Desc: tab name
     * @param {multilingualLanguagePickerOpenParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.multilingualLanguagePickerOpen = function (params) {
        return this.bi.log(__assign({ evid: 415 }, params));
    };
    /**
    * @typedef {Object} migrationUpdateAndPublishConfirmationClickParams
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_first - is it the first time the user opens this tab?
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} referral_info - referral_info
    * @property {string} role - role
    **/
    /**
     * Name: Migration -> Update and publish confirmation click. Evid: 392.
     * Event description: triggered when users click on Update and publish confirmation click.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_first - Type: bool. Desc: is it the first time the user opens this tab?
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * referral_info - Type: string. Desc: referral_info
     *
     * role - Type: string. Desc: role
     * @param {migrationUpdateAndPublishConfirmationClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationUpdateAndPublishConfirmationClick = function (params) {
        return this.bi.log(__assign({ evid: 392 }, params));
    };
    /**
    * @typedef {Object} modalActionParams
    * @property {string} action - Action on modal (for Draft refresh - close/save this version/discard this version)
    * @property {string} available_languages - an array with the available languages
    * @property {string} dataJson - if the modal has selections for the user those selections will be stored here
    * @property {string} default_language - default language
    * @property {GUID} instance_id - null
    * @property {string} language_selected - In multilingual context stores the language that the user chose
    * @property {string} modal_name - modal name
    * @property {GUID} biToken - null
    * @property {string} origin - origin
    * @property {string} role - role
    **/
    /**
     * Name: Modal action. Evid: 348.
     * Event description: Action on Modal - generic event for many different modals.
    
    --Draft refresh:
    Action on modal to refresh draft (there exists another version of the draft in another tab or Wix app).
    
     * action - Type: string. Desc: Action on modal (for Draft refresh - close/save this version/discard this version)
     *
     * available_languages - Type: string. Desc: an array with the available languages
     *
     * dataJson - Type: string. Desc: if the modal has selections for the user those selections will be stored here
     *
     * default_language - Type: string. Desc: default language
     *
     * instance_id - Type: guid.
     *
     * language_selected - Type: string. Desc: In multilingual context stores the language that the user chose
     *
     * modal_name - Type: string. Desc: modal name
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: origin
     *
     * role - Type: string. Desc: role
     * @param {modalActionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.modalAction = function (params) {
        return this.bi.log(__assign({ evid: 348 }, params));
    };
    /**
    * @typedef {Object} migrationKeepGoingClickParams
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_first - is it the first time the user opens this tab?
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} referral_info - referral_info
    * @property {string} role - role
    **/
    /**
     * Name: Migration -> Keep going click. Evid: 387.
     * Event description: triggered when users click on Keep going click.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_first - Type: bool. Desc: is it the first time the user opens this tab?
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * referral_info - Type: string. Desc: referral_info
     *
     * role - Type: string. Desc: role
     * @param {migrationKeepGoingClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationKeepGoingClick = function (params) {
        return this.bi.log(__assign({ evid: 387 }, params));
    };
    /**
    * @typedef {Object} migrationDoneClickParams
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_first - is it the first time the user opens this tab?
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} referral_info - referral_info
    * @property {string} role - role
    **/
    /**
     * Name: Migration -> done click. Evid: 394.
     * Event description: triggered when users click on done click.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_first - Type: bool. Desc: is it the first time the user opens this tab?
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * referral_info - Type: string. Desc: referral_info
     *
     * role - Type: string. Desc: role
     * @param {migrationDoneClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationDoneClick = function (params) {
        return this.bi.log(__assign({ evid: 394 }, params));
    };
    /**
    * @typedef {Object} oneAppGenericModalShownParams
    * @property {GUID} instance_id - instance
    * @property {string} modal_name - modal name
    * @property {GUID} biToken - msid
    * @property {string} origin - origin - the previous screen/modal
    * @property {string} role - role
    * @property {GUID} visitor_id - visitor
    **/
    /**
     * Name: OneApp - Generic Modal shown. Evid: 1320.
     * Event description: Modal shown - generic event for many different modals..
    
     * instance_id - Type: guid. Desc: instance
     *
     * modal_name - Type: string. Desc: modal name
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin - the previous screen/modal
     *
     * role - Type: string. Desc: role
     *
     * visitor_id - Type: guid. Desc: visitor
     * @param {oneAppGenericModalShownParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppGenericModalShown = function (params) {
        return this.bi.log(__assign({ evid: 1320 }, params));
    };
    /**
    * @typedef {Object} fullstorySessionParams
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    **/
    /**
     * Name: Fullstory session. Evid: 400.
     * Event description: triggered when a Fullstory session started.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     * @param {fullstorySessionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.fullstorySession = function (params) {
        return this.bi.log(__assign({ evid: 400 }, params));
    };
    /**
    * @typedef {Object} oneAppBlogSearchResultClickedParams
    * @property {GUID} author_id - author id
    * @property {string} category_id - category id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - Where tabs was opened (Manage)
    * @property {string} post_id - post id
    * @property {string} role - member role (owner, writer, member)
    * @property {string} tagid - tag id
    **/
    /**
     * Name: OneApp - Blog search result clicked. Evid: 1338.
     * Event description: After clicking on search in OneApp blog home.
    
     * author_id - Type: guid. Desc: author id
     *
     * category_id - Type: string. Desc: category id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: Where tabs was opened (Manage)
     *
     * post_id - Type: string. Desc: post id
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * tagid - Type: string. Desc: tag id
     * @param {oneAppBlogSearchResultClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppBlogSearchResultClicked = function (params) {
        return this.bi.log(__assign({ evid: 1338 }, params));
    };
    /**
    * @typedef {Object} oneAppCustomizeBlogSectionsParams
    * @property {string} app_id - app_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - Post Page Settings, app settings (feed)
    * @property {string} property - The setting name
    * @property {string} property_value - The setting value
    * @property {string} role - role
    * @property {string} section - which section is being edited. (header, navigation tabs, category list etc..)
    * @property {string} tab_name - tab name (member view or place card)
    **/
    /**
     * Name: OneApp - Customize blog sections. Evid: 1327.
     * Event description: When a user clicks customize from the admin menu on the blog tab. One app only!.
    
     * app_id - Type: string. Desc: app_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: Post Page Settings, app settings (feed)
     *
     * property - Type: string. Desc: The setting name
     *
     * property_value - Type: string. Desc: The setting value
     *
     * role - Type: string. Desc: role
     *
     * section - Type: string. Desc: which section is being edited. (header, navigation tabs, category list etc..)
     *
     * tab_name - Type: string. Desc: tab name (member view or place card)
     * @param {oneAppCustomizeBlogSectionsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppCustomizeBlogSections = function (params) {
        return this.bi.log(__assign({ evid: 1327 }, params));
    };
    /**
    * @typedef {Object} migrationCloseModalClickParams
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_first - is it the first time the user opens this tab?
    * @property {string} modal_name - post transferred, success
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} referral_info - referral_info
    * @property {string} role - role
    **/
    /**
     * Name: Migration -> Close modal click. Evid: 388.
     * Event description: triggered when users click on Keep going click.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_first - Type: bool. Desc: is it the first time the user opens this tab?
     *
     * modal_name - Type: string. Desc: post transferred, success
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * referral_info - Type: string. Desc: referral_info
     *
     * role - Type: string. Desc: role
     * @param {migrationCloseModalClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationCloseModalClick = function (params) {
        return this.bi.log(__assign({ evid: 388 }, params));
    };
    /**
    * @typedef {Object} oneAppTabOpenedInManageParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - msid
    * @property {string} origin - Where tabs was opened (Manage)
    * @property {string} role - member role (owner, writer, member)
    * @property {string} tab_name - tab name opened in Manage
    **/
    /**
     * Name: OneApp Tab opened in Manage. Evid: 1301.
     * Event description: User opened tab in OneApp Manage section.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: Where tabs was opened (Manage)
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * tab_name - Type: string. Desc: tab name opened in Manage
     * @param {oneAppTabOpenedInManageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppTabOpenedInManage = function (params) {
        return this.bi.log(__assign({ evid: 1301 }, params));
    };
    /**
    * @typedef {Object} migrationImportPageSecondStepOpenedParams
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_first - is it the first time the user opens this tab?
    * @property {string} migration_status - First time, In progress, Done (after finishing migration)
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} referral_info - referral_info
    * @property {string} role - role
    **/
    /**
     * Name: Migration -> Import page second step opened. Evid: 389.
     * Event description: triggered when Migration Import page second step actually open.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_first - Type: bool. Desc: is it the first time the user opens this tab?
     *
     * migration_status - Type: string. Desc: First time, In progress, Done (after finishing migration)
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * referral_info - Type: string. Desc: referral_info
     *
     * role - Type: string. Desc: role
     * @param {migrationImportPageSecondStepOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationImportPageSecondStepOpened = function (params) {
        return this.bi.log(__assign({ evid: 389 }, params));
    };
    /**
    * @typedef {Object} multilingualCategoryTranslateClickParams
    * @property {GUID} app_id - app_id (forum, blog, members)
    * @property {string} category_id - category id
    * @property {string} community_id - community_id (instance of members app)
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} role - member role (owner, writer, member)
    * @property {GUID} site_member_id - site_member_id
    * @property {string} translation_id - the category id of the translated post
    **/
    /**
     * Name: Multilingual - category translate click. Evid: 417.
     * Event description: triggered when click on translate CTA.
    
     * app_id - Type: guid. Desc: app_id (forum, blog, members)
     *
     * category_id - Type: string. Desc: category id
     *
     * community_id - Type: string. Desc: community_id (instance of members app)
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * translation_id - Type: string. Desc: the category id of the translated post
     * @param {multilingualCategoryTranslateClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.multilingualCategoryTranslateClick = function (params) {
        return this.bi.log(__assign({ evid: 417 }, params));
    };
    /**
    * @typedef {Object} blogSettingsEditSeoBlogCategoriesClickParams
    * @property {GUID} instance_id - instance
    * @property {GUID} biToken - msid
    * @property {string} origin - origin
    * @property {string} referrer - referrer
    * @property {string} role - role
    **/
    /**
     * Name: Blog settings - Manage Notifications and emails click. Evid: 369.
     * Event description: triggered when the user clicks on the edit button on the Blog settings screen, under the SEO settings section..
    
     * instance_id - Type: guid. Desc: instance
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin
     *
     * referrer - Type: string. Desc: referrer
     *
     * role - Type: string. Desc: role
     * @param {blogSettingsEditSeoBlogCategoriesClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.blogSettingsEditSeoBlogCategoriesClick = function (params) {
        return this.bi.log(__assign({ evid: 369 }, params));
    };
    /**
    * @typedef {Object} postPublishedParams
    * @property {GUID} app_id - app_id (forum, blog, members)
    * @property {number} categories_count - NOT IN USE: categories_count that post was assigned to
    * @property {string} category_ids - category_ids. JSON array string
    * @property {number} character_count - The number of characters on the post
    * @property {string} community_id - NOT IN USE: community_id (instance of members app)
    * @property {string} galleries - will sent as array - [{ layout: 'masonry', count: 5}, { layout: 'whatever', count: 10 }]
    * @property {number} giphy_count - count of used  giphy gifs
    * @property {boolean} has_gallery - NOT IN USE: 0 - no gallery / 1 - published with gallery
    * @property {number} image_count - image_count in the post
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_edited - 0 - new post / 1 - edit (to know if its posted for first time)
    * @property {boolean} is_published - 0 - not published (draft) / 1 - published
    * @property {string} language - for multilingual
    * @property {string} member_id - member_id
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {GUID} original_instance_id - Currently being used for wix reads posts.in the members app events. holds the child app (forum/blog) instance_id
    * @property {string} original_post_id - the original post id
    * @property {string} paid_plan_id - Array of paid plan ids
    * @property {string} post_id - post_id
    * @property {GUID} post_stable_id - stable id
    * @property {string} post_title - post title
    * @property {string} referral_info - NOT IN USE: external links - facebook, social networks. if from wix then null
    * @property {string} related_post_ids - array with related post Ids
    * @property {string} role - member role (owner, writer, member)
    * @property {string} tag_ids - array of tags
    * @property {string} translation_id - the post_stable_id of the post that was translated
    * @property {boolean} used_html - 0 - didnt used html component / 1 - used html component
    * @property {number} video_count - video_count in the post
    **/
    /**
     * Name: post published. Evid: 303.
     * Event description: triggered when post published (including all cross propeties- important).
    
     * app_id - Type: guid. Desc: app_id (forum, blog, members)
     *
     * categories_count - Type: numeric. Desc: NOT IN USE: categories_count that post was assigned to
     *
     * category_ids - Type: string. Desc: category_ids. JSON array string
     *
     * character_count - Type: numeric. Desc: The number of characters on the post
     *
     * community_id - Type: string. Desc: NOT IN USE: community_id (instance of members app)
     *
     * galleries - Type: string. Desc: will sent as array - [{ layout: 'masonry', count: 5}, { layout: 'whatever', count: 10 }]
     *
     * giphy_count - Type: numeric. Desc: count of used  giphy gifs
     *
     * has_gallery - Type: bool. Desc: NOT IN USE: 0 - no gallery / 1 - published with gallery
     *
     * image_count - Type: numeric. Desc: image_count in the post
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_edited - Type: bool. Desc: 0 - new post / 1 - edit (to know if its posted for first time)
     *
     * is_published - Type: bool. Desc: 0 - not published (draft) / 1 - published
     *
     * language - Type: string. Desc: for multilingual
     *
     * member_id - Type: string. Desc: member_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * original_instance_id - Type: guid. Desc: Currently being used for wix reads posts.in the members app events. holds the child app (forum/blog) instance_id
     *
     * original_post_id - Type: string. Desc: the original post id
     *
     * paid_plan_id - Type: string. Desc: Array of paid plan ids
     *
     * post_id - Type: string. Desc: post_id
     *
     * post_stable_id - Type: guid. Desc: stable id
     *
     * post_title - Type: string. Desc: post title
     *
     * referral_info - Type: string. Desc: NOT IN USE: external links - facebook, social networks. if from wix then null
     *
     * related_post_ids - Type: string. Desc: array with related post Ids
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * tag_ids - Type: string. Desc: array of tags
     *
     * translation_id - Type: string. Desc: the post_stable_id of the post that was translated
     *
     * used_html - Type: bool. Desc: 0 - didnt used html component / 1 - used html component
     *
     * video_count - Type: numeric. Desc: video_count in the post
     * @param {postPublishedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postPublished = function (params) {
        return this.bi.log(__assign({ evid: 303 }, params));
    };
    /**
    * @typedef {Object} oneAppClickInsideSwipeActionParams
    * @property {string} action - Settings/Edit
    * @property {GUID} instance_id - null
    * @property {boolean} is_published - 0 - not published (draft) / 1 - published
    * @property {GUID} biToken - msid
    * @property {string} origin - OneApp Manage
    * @property {string} post_id - post_id
    * @property {GUID} post_stable_id - stable id
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: OneApp click inside swipe action. Evid: 1304.
     * Event description: User chose action after swipe.
    
     * action - Type: string. Desc: Settings/Edit
     *
     * instance_id - Type: guid.
     *
     * is_published - Type: bool. Desc: 0 - not published (draft) / 1 - published
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: OneApp Manage
     *
     * post_id - Type: string. Desc: post_id
     *
     * post_stable_id - Type: guid. Desc: stable id
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {oneAppClickInsideSwipeActionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppClickInsideSwipeAction = function (params) {
        return this.bi.log(__assign({ evid: 1304 }, params));
    };
    /**
    * @typedef {Object} oneAppPreviousNextPostArrowClickParams
    * @property {string} action - previous or next post
    * @property {GUID} instance_id - instance
    * @property {GUID} biToken - msid
    * @property {string} origin - post page
    * @property {string} post_id - post_id
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: OneApp - Previous/Next post arrow click. Evid: 1339.
     * Event description: the user clicked on the previous or next post within the post page.
    
     * action - Type: string. Desc: previous or next post
     *
     * instance_id - Type: guid. Desc: instance
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: post page
     *
     * post_id - Type: string. Desc: post_id
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {oneAppPreviousNextPostArrowClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppPreviousNextPostArrowClick = function (params) {
        return this.bi.log(__assign({ evid: 1339 }, params));
    };
    /**
    * @typedef {Object} followUnfollowCategoryClickWixReadsParams
    * @property {string} category_id - category id
    * @property {string} category_name - category name
    * @property {GUID} instance_id - instance
    * @property {boolean} is_followed - 1- followed, 0 - unfollowed
    * @property {GUID} biToken - msid
    * @property {string} origin - origin
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: follow/unfollow category click (wix reads). Evid: 1328.
     * Event description: When the user clicks to follow or unfollow.
    
     * category_id - Type: string. Desc: category id
     *
     * category_name - Type: string. Desc: category name
     *
     * instance_id - Type: guid. Desc: instance
     *
     * is_followed - Type: bool. Desc: 1- followed, 0 - unfollowed
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {followUnfollowCategoryClickWixReadsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.followUnfollowCategoryClickWixReads = function (params) {
        return this.bi.log(__assign({ evid: 1328 }, params));
    };
    /**
    * @typedef {Object} migrationLearnHowToSwitchDeleteOldBlogParams
    * @property {string} action - switch, delete
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - old blog 6th button
    * @property {string} role - role
    **/
    /**
     * Name: Migration -> Learn How to Switch / Delete old blog. Evid: 398.
     * Event description: Whenever the user clicks on the learn how link from the old blog 6th button - learn how to delete, learn how to switch.
    
     * action - Type: string. Desc: switch, delete
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: old blog 6th button
     *
     * role - Type: string. Desc: role
     * @param {migrationLearnHowToSwitchDeleteOldBlogParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationLearnHowToSwitchDeleteOldBlog = function (params) {
        return this.bi.log(__assign({ evid: 398 }, params));
    };
    /**
    * @typedef {Object} blogSettingsEditSeoBlogPostsClickParams
    * @property {string} click_name - which cta the user clicked: Posts, Categories or Tags
    * @property {GUID} instance_id - instance
    * @property {GUID} biToken - msid
    * @property {string} origin - origin
    * @property {string} referrer - referrer
    * @property {string} role - role
    **/
    /**
     * Name: Blog settings - SEO Patterns CTA click. Evid: 368.
     * Event description: triggered when the user clicks on the edit button on the Blog settings screen, under the SEO settings section..
    
     * click_name - Type: string. Desc: which cta the user clicked: Posts, Categories or Tags
     *
     * instance_id - Type: guid. Desc: instance
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin
     *
     * referrer - Type: string. Desc: referrer
     *
     * role - Type: string. Desc: role
     * @param {blogSettingsEditSeoBlogPostsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.blogSettingsEditSeoBlogPostsClick = function (params) {
        return this.bi.log(__assign({ evid: 368 }, params));
    };
    /**
    * @typedef {Object} oneappManageSearchTextEnteredParams
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - Where tabs was opened (Manage)
    * @property {string} role - member role (owner, writer, member)
    * @property {string} text - Text entered in a search
    **/
    /**
     * Name: Oneapp Manage search text entered. Evid: 1308.
     * Event description: After text was entered in search.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: Where tabs was opened (Manage)
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * text - Type: string. Desc: Text entered in a search
     * @param {oneappManageSearchTextEnteredParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneappManageSearchTextEntered = function (params) {
        return this.bi.log(__assign({ evid: 1308 }, params));
    };
    /**
    * @typedef {Object} blogTabInBmOpenedParams
    * @property {GUID} instance_id - instance_id
    * @property {string} language - the language that was rendered
    * @property {GUID} bi_token - msid
    * @property {GUID} biToken - null
    * @property {string} name - Opened Tab name in Blog Back Office
    * @property {string} place - Place where tab was opened (sidebar / blog posts list)
    * @property {string} referrer - from which place it was opened
    * @property {string} role - Role of user - writer or admin
    * @property {GUID} site_member_id - site_member_id
    * @property {string} tab_name - Opened Tab in Blog Back Office
    **/
    /**
     * Name: Blog tab in BM opened. Evid: 325.
     * Event description: Tab in Blog Manager opened.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * language - Type: string. Desc: the language that was rendered
     *
     * bi_token - Type: guid. Desc: msid
     *
     * biToken - Type: guid.
     *
     * name - Type: string. Desc: Opened Tab name in Blog Back Office
     *
     * place - Type: string. Desc: Place where tab was opened (sidebar / blog posts list)
     *
     * referrer - Type: string. Desc: from which place it was opened
     *
     * role - Type: string. Desc: Role of user - writer or admin
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * tab_name - Type: string. Desc: Opened Tab in Blog Back Office
     * @param {blogTabInBmOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.blogTabInBmOpened = function (params) {
        return this.bi.log(__assign({ evid: 325 }, params));
    };
    /**
    * @typedef {Object} postSelectorActionParams
    * @property {string} action - The button that the user clicked, Cancel, Done, 'X'
    * @property {GUID} instance_id - instance
    * @property {GUID} biToken - msid
    * @property {string} origin - origin
    * @property {string} post_id - post_id if applicable
    * @property {string} post_ids - array of post_id
    * @property {string} role - role
    **/
    /**
     * Name: Post Selector Action. Evid: 359.
     * Event description: triggered when the user closes the post selector. Stores the.
    
     * action - Type: string. Desc: The button that the user clicked, Cancel, Done, 'X'
     *
     * instance_id - Type: guid. Desc: instance
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin
     *
     * post_id - Type: string. Desc: post_id if applicable
     *
     * post_ids - Type: string. Desc: array of post_id
     *
     * role - Type: string. Desc: role
     * @param {postSelectorActionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postSelectorAction = function (params) {
        return this.bi.log(__assign({ evid: 359 }, params));
    };
    /**
    * @typedef {Object} blogWidgetElementRemovedParams
    * @property {GUID} instance_id - instance
    * @property {GUID} biToken - msid
    * @property {string} origin - origin - examples: related_posts, paid_plans etc..
    * @property {string} post_id - post_id if applicable
    * @property {string} role - role
    **/
    /**
     * Name: Post Selector Shown. Evid: 358.
     * Event description: Triggered when the user clicks on a CTA that requires selecting multiple posts..
    
     * instance_id - Type: guid. Desc: instance
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin - examples: related_posts, paid_plans etc..
     *
     * post_id - Type: string. Desc: post_id if applicable
     *
     * role - Type: string. Desc: role
     * @param {blogWidgetElementRemovedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.blogWidgetElementRemoved = function (params) {
        return this.bi.log(__assign({ evid: 358 }, params));
    };
    /**
    * @typedef {Object} migrationCopyPostsClickParams
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_first - is it the first time the user opens this tab?
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} referral_info - referral_info
    * @property {string} role - role
    **/
    /**
     * Name: Migration -> Copy posts click. Evid: 385.
     * Event description: triggered when users click on Copy posts.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_first - Type: bool. Desc: is it the first time the user opens this tab?
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * referral_info - Type: string. Desc: referral_info
     *
     * role - Type: string. Desc: role
     * @param {migrationCopyPostsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationCopyPostsClick = function (params) {
        return this.bi.log(__assign({ evid: 385 }, params));
    };
    /**
    * @typedef {Object} oneAppBlogSearchClickedParams
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - Where tabs was opened (Manage)
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: OneApp - Blog search clicked. Evid: 1335.
     * Event description: After clicking on search in OneApp blog home.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: Where tabs was opened (Manage)
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {oneAppBlogSearchClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppBlogSearchClicked = function (params) {
        return this.bi.log(__assign({ evid: 1335 }, params));
    };
    /**
    * @typedef {Object} blog6thButtonBlogElementAddedParams
    * @property {string} editor_working_mode - dummy
    * @property {string} element_type - recent post, custom feed
    * @property {GUID} esi - dummy
    * @property {GUID} id - unique id of a widget to connect to other events
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_first_time_view - dummy
    * @property {string} layout - layout of the element that was added
    * @property {GUID} biToken - msid
    * @property {string} origin - 6th button or Add panel
    * @property {string} pageType - the page the widget was added on. Home, Post, other
    * @property {number} ts - dummy
    * @property {string} viewmode - dummy
    * @property {string} widget_id - widget_id
    **/
    /**
     * Name: blog widget (element) added. Evid: 322.
     * Event description: triggered when adding blog element from the blog 6th button.
    
     * editor_working_mode - Type: string. Desc: dummy
     *
     * element_type - Type: string. Desc: recent post, custom feed
     *
     * esi - Type: guid. Desc: dummy
     *
     * id - Type: guid. Desc: unique id of a widget to connect to other events
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_first_time_view - Type: bool. Desc: dummy
     *
     * layout - Type: string. Desc: layout of the element that was added
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: 6th button or Add panel
     *
     * pageType - Type: string. Desc: the page the widget was added on. Home, Post, other
     *
     * ts - Type: numeric. Desc: dummy
     *
     * viewmode - Type: string. Desc: dummy
     *
     * widget_id - Type: string. Desc: widget_id
     * @param {blog6thButtonBlogElementAddedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.blog6thButtonBlogElementAdded = function (params) {
        return this.bi.log(__assign({ evid: 322 }, params));
    };
    /**
    * @typedef {Object} migrationUpdateAndPublishClickParams
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_first - is it the first time the user opens this tab?
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} referral_info - referral_info
    * @property {string} role - role
    **/
    /**
     * Name: Migration -> Update and publish click. Evid: 390.
     * Event description: triggered when users click on Update and publish click.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_first - Type: bool. Desc: is it the first time the user opens this tab?
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * referral_info - Type: string. Desc: referral_info
     *
     * role - Type: string. Desc: role
     * @param {migrationUpdateAndPublishClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationUpdateAndPublishClick = function (params) {
        return this.bi.log(__assign({ evid: 390 }, params));
    };
    /**
    * @typedef {Object} oneAppGenericActionSheetShownParams
    * @property {string} action_sheet_name - action sheet name
    * @property {GUID} instance_id - instance
    * @property {GUID} biToken - msid
    * @property {string} origin - origin - the previous screen/modal
    * @property {string} role - role
    * @property {GUID} visitor_id - visitor
    **/
    /**
     * Name: OneApp - Generic action sheet shown. Evid: 1324.
     * Event description: Action sheet showed - a generic event for many different action sheets..
    
     * action_sheet_name - Type: string. Desc: action sheet name
     *
     * instance_id - Type: guid. Desc: instance
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin - the previous screen/modal
     *
     * role - Type: string. Desc: role
     *
     * visitor_id - Type: guid. Desc: visitor
     * @param {oneAppGenericActionSheetShownParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppGenericActionSheetShown = function (params) {
        return this.bi.log(__assign({ evid: 1324 }, params));
    };
    /**
    * @typedef {Object} authorEditedParams
    * @property {GUID} author_id - Author id = site member id
    * @property {string} author_role - Currently just "Offline/Owner" - might be reused later
    * @property {boolean} cover_changed - cover has changed
    * @property {boolean} has_cover - does have a cover image
    * @property {boolean} has_picture - TRUE if author already has a picture (nice to have)
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} new_author_name - new name after edit
    * @property {string} new_author_title - new title after edit
    * @property {string} origin - origin
    * @property {boolean} was_name_changed - null
    * @property {boolean} was_picture_changed - if picture was changed on editing author
    **/
    /**
     * Name: Author edited. Evid: 366.
    
    
     * author_id - Type: guid. Desc: Author id = site member id
     *
     * author_role - Type: string. Desc: Currently just "Offline/Owner" - might be reused later
     *
     * cover_changed - Type: bool. Desc: cover has changed
     *
     * has_cover - Type: bool. Desc: does have a cover image
     *
     * has_picture - Type: bool. Desc: TRUE if author already has a picture (nice to have)
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * new_author_name - Type: string. Desc: new name after edit
     *
     * new_author_title - Type: string. Desc: new title after edit
     *
     * origin - Type: string. Desc: origin
     *
     * was_name_changed - Type: bool.
     *
     * was_picture_changed - Type: bool. Desc: if picture was changed on editing author
     * @param {authorEditedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.authorEdited = function (params) {
        return this.bi.log(__assign({ evid: 366 }, params));
    };
    /**
    * @typedef {Object} blogSettingsOpenedInBmParams
    * @property {string} app_id - app_id
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - BM_posts
    * @property {string} role - role
    **/
    /**
     * Name: Blog settings opened (in BM). Evid: 360.
     * Event description: Blog settings opened (in BM).
    
     * app_id - Type: string. Desc: app_id
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: BM_posts
     *
     * role - Type: string. Desc: role
     * @param {blogSettingsOpenedInBmParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.blogSettingsOpenedInBm = function (params) {
        return this.bi.log(__assign({ evid: 360 }, params));
    };
    /**
    * @typedef {Object} postPageMigrationSuccessParams
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} role - role
    **/
    /**
     * Name: Post page Migration success. Evid: 355.
     * Event description: triggered when users successfully migrated.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * role - Type: string. Desc: role
     * @param {postPageMigrationSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postPageMigrationSuccess = function (params) {
        return this.bi.log(__assign({ evid: 355 }, params));
    };
    /**
    * @typedef {Object} errorMessageShowCtaClickParams
    * @property {string} action - the cta clicked - customer care, cancel ... others
    * @property {number} error_code - http error code
    * @property {string} error_message - error message
    * @property {string} error_type - error type
    * @property {GUID} instance_id - instance
    * @property {GUID} biToken - msid
    * @property {string} origin - origin
    * @property {string} role - role
    * @property {string} type - The way it was displayed: Tooltip, Modal, toast etc..
    **/
    /**
     * Name: error message show cta click. Evid: 373.
     * Event description: whenever an error msg cta is clicked (customer care, cancel etc..).
    
     * action - Type: string. Desc: the cta clicked - customer care, cancel ... others
     *
     * error_code - Type: numeric. Desc: http error code
     *
     * error_message - Type: string. Desc: error message
     *
     * error_type - Type: string. Desc: error type
     *
     * instance_id - Type: guid. Desc: instance
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin
     *
     * role - Type: string. Desc: role
     *
     * type - Type: string. Desc: The way it was displayed: Tooltip, Modal, toast etc..
     * @param {errorMessageShowCtaClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.errorMessageShowCtaClick = function (params) {
        return this.bi.log(__assign({ evid: 373 }, params));
    };
    /**
    * @typedef {Object} modalShownParams
    * @property {GUID} instance_id - null
    * @property {string} modal_name - modal name
    * @property {GUID} biToken - null
    * @property {string} origin - origin
    * @property {string} role - role
    **/
    /**
     * Name: Modal shown. Evid: 347.
     * Event description: Modal shown - generic event for many different modals.
    
    --Draft refresh:
    Modal to refresh draft shown (there exists another version of the draft in another tab or Wix app).
    
     * instance_id - Type: guid.
     *
     * modal_name - Type: string. Desc: modal name
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: origin
     *
     * role - Type: string. Desc: role
     * @param {modalShownParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.modalShown = function (params) {
        return this.bi.log(__assign({ evid: 347 }, params));
    };
    /**
    * @typedef {Object} postPagePostPageSettingsDisplayTabParams
    * @property {string} app_id - app_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - Post Page Settings, app settings (feed)
    * @property {string} property - the property that was changed
    * @property {string} property_value - the value of the property
    * @property {string} role - role
    * @property {string} section - setting name, i.e. author name and picture, date and reading time, login from blog menu,  etc.
    * @property {boolean} toggle - toggle, 1 if checked, 0 if unchecked
    **/
    /**
     * Name: editor - settings display tab. Evid: 353.
     * Event description: Tab inside post page opened.
    
     * app_id - Type: string. Desc: app_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: Post Page Settings, app settings (feed)
     *
     * property - Type: string. Desc: the property that was changed
     *
     * property_value - Type: string. Desc: the value of the property
     *
     * role - Type: string. Desc: role
     *
     * section - Type: string. Desc: setting name, i.e. author name and picture, date and reading time, login from blog menu,  etc.
     *
     * toggle - Type: bool. Desc: toggle, 1 if checked, 0 if unchecked
     * @param {postPagePostPageSettingsDisplayTabParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postPagePostPageSettingsDisplayTab = function (params) {
        return this.bi.log(__assign({ evid: 353 }, params));
    };
    /**
    * @typedef {Object} postFeedFilterSettingsCategoryAndTagsParams
    * @property {string} category_id - category Id
    * @property {string} category_name - category name
    * @property {GUID} category_stable_id - category stable id
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} role - role
    * @property {GUID} tag_guid - tag stable id
    * @property {string} tagid - tag_id, null if user selected all posts
    * @property {string} tag_name - tag label
    **/
    /**
     * Name: Post feed filter settings - category and tags. Evid: 318.
     * Event description: Whenever a user selects a filter for the post list from the settings button..
    
     * category_id - Type: string. Desc: category Id
     *
     * category_name - Type: string. Desc: category name
     *
     * category_stable_id - Type: guid. Desc: category stable id
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: role
     *
     * tag_guid - Type: guid. Desc: tag stable id
     *
     * tagid - Type: string. Desc: tag_id, null if user selected all posts
     *
     * tag_name - Type: string. Desc: tag label
     * @param {postFeedFilterSettingsCategoryAndTagsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postFeedFilterSettingsCategoryAndTags = function (params) {
        return this.bi.log(__assign({ evid: 318 }, params));
    };
    /**
    * @typedef {Object} errorEventParams
    * @property {string} action - which action triggered the error ( e.g. scheduling a post, publishing a post etc)
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    **/
    /**
     * Name: error event in post editor in BO. Evid: 338.
     * Event description: whenever the user sees an error message in post editor. Not sent if internet is gone for user, but user sees modal.
    
     * action - Type: string. Desc: which action triggered the error ( e.g. scheduling a post, publishing a post etc)
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     * @param {errorEventParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.errorEvent = function (params) {
        return this.bi.log(__assign({ evid: 338 }, params));
    };
    /**
    * @typedef {Object} oneAppBlogOnboardingStepsButtonClickParams
    * @property {string} button_name - add post, skip, undo etc...
    * @property {GUID} instance_id - instance
    * @property {GUID} biToken - msid
    * @property {string} origin - manage blog
    * @property {string} role - member role (owner, writer, member)
    * @property {string} step_name - add your first post, invite members etc..
    **/
    /**
     * Name: OneApp - Blog Onboarding steps button click. Evid: 1334.
     * Event description: The user clicked a button on the onboarding.
    
     * button_name - Type: string. Desc: add post, skip, undo etc...
     *
     * instance_id - Type: guid. Desc: instance
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: manage blog
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * step_name - Type: string. Desc: add your first post, invite members etc..
     * @param {oneAppBlogOnboardingStepsButtonClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppBlogOnboardingStepsButtonClick = function (params) {
        return this.bi.log(__assign({ evid: 1334 }, params));
    };
    /**
    * @typedef {Object} forumsSettingsChooseYourForumStructureParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} type - 'List of Categoire' or 'List of all posts'
    * @property {GUID} uuid - app_id (forum, blog, members)
    **/
    /**
     * Name: Forums settings: choose your forum structure. Evid: 302.
     * Event description: triggered when forum structure options switched.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * type - Type: string. Desc: 'List of Categoire' or 'List of all posts'
     *
     * uuid - Type: guid. Desc: app_id (forum, blog, members)
     * @param {forumsSettingsChooseYourForumStructureParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumsSettingsChooseYourForumStructure = function (params) {
        return this.bi.log(__assign({ evid: 302 }, params));
    };
    /**
    * @typedef {Object} oneAppManageCategoriesAddNewCategoryClickParams
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - Where tabs was opened (Manage)
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: OneApp Manage Categories Add new category click. Evid: 1312.
     * Event description: Clicked on add new category button in OneApp.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: Where tabs was opened (Manage)
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {oneAppManageCategoriesAddNewCategoryClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppManageCategoriesAddNewCategoryClick = function (params) {
        return this.bi.log(__assign({ evid: 1312 }, params));
    };
    /**
    * @typedef {Object} emailMarketingSelectPostParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    * @property {string} role - role
    **/
    /**
     * Name: Email Marketing Select Post. Evid: 335.
     * Event description: Whenever the user selects a post from the Email marketing post selection modal..
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     *
     * role - Type: string. Desc: role
     * @param {emailMarketingSelectPostParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.emailMarketingSelectPost = function (params) {
        return this.bi.log(__assign({ evid: 335 }, params));
    };
    /**
    * @typedef {Object} blogSettingsBackToBlogSettingsToastClickParams
    * @property {GUID} instance_id - instance
    * @property {GUID} biToken - msid
    * @property {string} origin - origin
    * @property {string} referrer - referrer
    * @property {string} role - role
    **/
    /**
     * Name: Blog settings - Back to blog settings toast click. Evid: 370.
     * Event description: triggered when the user clicks on the back to blog settings toast on the SEO patterns screens.
    
     * instance_id - Type: guid. Desc: instance
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin
     *
     * referrer - Type: string. Desc: referrer
     *
     * role - Type: string. Desc: role
     * @param {blogSettingsBackToBlogSettingsToastClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.blogSettingsBackToBlogSettingsToastClick = function (params) {
        return this.bi.log(__assign({ evid: 370 }, params));
    };
    /**
    * @typedef {Object} postEditorHoverOnUpgradeParams
    * @property {GUID} instance_id - instance
    * @property {boolean} is_edited - is_edited
    * @property {boolean} is_published - Is post published
    * @property {GUID} biToken - null
    * @property {string} origin - origin
    * @property {string} post_id - post id
    * @property {string} role - role
    **/
    /**
     * Name: Post Editor: hover on Upgrade. Evid: 342.
     * Event description: User hover on upgrade button in post editor.
    
     * instance_id - Type: guid. Desc: instance
     *
     * is_edited - Type: bool. Desc: is_edited
     *
     * is_published - Type: bool. Desc: Is post published
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: origin
     *
     * post_id - Type: string. Desc: post id
     *
     * role - Type: string. Desc: role
     * @param {postEditorHoverOnUpgradeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postEditorHoverOnUpgrade = function (params) {
        return this.bi.log(__assign({ evid: 342 }, params));
    };
    /**
    * @typedef {Object} advancedPostSettingsDoneClickParams
    * @property {string} button_name - Save, Save and Publish
    * @property {number} categories_chosen - How many categories was chosen
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_author_changed - User changed author
    * @property {boolean} is_changed_excerpt - If excerpt was changed
    * @property {boolean} is_changed_search_engine_title - Changed search engine title
    * @property {boolean} is_changed_url - Changed URL
    * @property {boolean} is_cover_image_changed - Changed cover image
    * @property {boolean} is_display_cover_toggle_changed - If toggle was changed
    * @property {boolean} is_excerpt_written - 1 - added text, 0 - didn't
    * @property {boolean} is_feature_post_toggle_changed - If toggle was changed
    * @property {boolean} is_on_feature_post_toggle - 1 - on, 0 - off
    * @property {boolean} is_publish_date_edited - Post publish date edited
    * @property {boolean} is_published - Is post published (1-published)
    * @property {boolean} is_written_description - Written a description
    * @property {GUID} bi_token - MSID
    * @property {GUID} biToken - null
    * @property {string} platform - Was opened in back office/live site
    * @property {string} role - Role of user - writer or admin
    * @property {boolean} is_on_display_cover_toggle - 1 - on, 0 - off
    **/
    /**
     * Name: Advanced post settings Done click. Evid: 323.
     * Event description: Clicking Done in advance post settings.
    
     * button_name - Type: string. Desc: Save, Save and Publish
     *
     * categories_chosen - Type: numeric. Desc: How many categories was chosen
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_author_changed - Type: bool. Desc: User changed author
     *
     * is_changed_excerpt - Type: bool. Desc: If excerpt was changed
     *
     * is_changed_search_engine_title - Type: bool. Desc: Changed search engine title
     *
     * is_changed_url - Type: bool. Desc: Changed URL
     *
     * is_cover_image_changed - Type: bool. Desc: Changed cover image
     *
     * is_display_cover_toggle_changed - Type: bool. Desc: If toggle was changed
     *
     * is_excerpt_written - Type: bool. Desc: 1 - added text, 0 - didn't
     *
     * is_feature_post_toggle_changed - Type: bool. Desc: If toggle was changed
     *
     * is_on_feature_post_toggle - Type: bool. Desc: 1 - on, 0 - off
     *
     * is_publish_date_edited - Type: bool. Desc: Post publish date edited
     *
     * is_published - Type: bool. Desc: Is post published (1-published)
     *
     * is_written_description - Type: bool. Desc: Written a description
     *
     * bi_token - Type: guid. Desc: MSID
     *
     * biToken - Type: guid.
     *
     * platform - Type: string. Desc: Was opened in back office/live site
     *
     * role - Type: string. Desc: Role of user - writer or admin
     *
     * is_on_display_cover_toggle - Type: bool. Desc: 1 - on, 0 - off
     * @param {advancedPostSettingsDoneClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.advancedPostSettingsDoneClick = function (params) {
        return this.bi.log(__assign({ evid: 323 }, params));
    };
    /**
    * @typedef {Object} tagDeletedParams
    * @property {GUID} instance_id - null
    * @property {string} language - language
    * @property {GUID} biToken - null
    * @property {string} origin - where did he deleted
    * @property {string} role - role
    * @property {GUID} tag_guid - tag stable id
    * @property {string} tagid - tag id
    * @property {string} tag_name - tag name
    * @property {string} translation_id - translation id
    **/
    /**
     * Name: tag removed from post. Evid: 319.
     * Event description: Taga was removed from post.
    
     * instance_id - Type: guid.
     *
     * language - Type: string. Desc: language
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: where did he deleted
     *
     * role - Type: string. Desc: role
     *
     * tag_guid - Type: guid. Desc: tag stable id
     *
     * tagid - Type: string. Desc: tag id
     *
     * tag_name - Type: string. Desc: tag name
     *
     * translation_id - Type: string. Desc: translation id
     * @param {tagDeletedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.tagDeleted = function (params) {
        return this.bi.log(__assign({ evid: 319 }, params));
    };
    /**
    * @typedef {Object} currentlyNotActiveGoToLiveSiteClickParams
    * @property {GUID} app_id - app_id (forum, blog, members)
    * @property {string} community_id - community_id (instance of members app)
    * @property {GUID} instance_id - instance_id
    * @property {string} member_id - member_id
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
    * @property {string} referral_info - external links - facebook, social networks. if from wix then null
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: currently not active - go to live site click. Evid: 310.
     * Event description: triggered when click on "go to live site" CTA inside the blog manager.
    
     * app_id - Type: guid. Desc: app_id (forum, blog, members)
     *
     * community_id - Type: string. Desc: community_id (instance of members app)
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * member_id - Type: string. Desc: member_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * original_instance_id - Type: guid. Desc: in the members app events. holds the child app (forum/blog) instance_id
     *
     * referral_info - Type: string. Desc: external links - facebook, social networks. if from wix then null
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {currentlyNotActiveGoToLiveSiteClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.currentlyNotActiveGoToLiveSiteClick = function (params) {
        return this.bi.log(__assign({ evid: 310 }, params));
    };
    /**
    * @typedef {Object} dotsPostEditorOptionClickedParams
    * @property {string} action - Preview Post, Post Settings, Choose Category, Save as Draft, Schedule Post
    * @property {GUID} instance_id - instance
    * @property {boolean} is_edited - is_edited
    * @property {boolean} is_published - Is post published
    * @property {string} language - Language
    * @property {GUID} biToken - null
    * @property {string} origin - origin
    * @property {string} post_id - post id
    * @property {GUID} post_stable_id - post. stable id
    * @property {string} role - role
    * @property {boolean} title_ok - is title set
    * @property {string} translation_id - translation_id
    **/
    /**
     * Name: Post Editor: action click. Evid: 340.
     * Event description: Whenever a user clicks one of the options from the 3 dots menu, in the Post Editor.
    
     * action - Type: string. Desc: Preview Post, Post Settings, Choose Category, Save as Draft, Schedule Post
     *
     * instance_id - Type: guid. Desc: instance
     *
     * is_edited - Type: bool. Desc: is_edited
     *
     * is_published - Type: bool. Desc: Is post published
     *
     * language - Type: string. Desc: Language
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: origin
     *
     * post_id - Type: string. Desc: post id
     *
     * post_stable_id - Type: guid. Desc: post. stable id
     *
     * role - Type: string. Desc: role
     *
     * title_ok - Type: bool. Desc: is title set
     *
     * translation_id - Type: string. Desc: translation_id
     * @param {dotsPostEditorOptionClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dotsPostEditorOptionClicked = function (params) {
        return this.bi.log(__assign({ evid: 340 }, params));
    };
    /**
    * @typedef {Object} oneappManageSearchResultsParams
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {number} num_posts_found - Number of posts found in search
    * @property {string} origin - Where tabs was opened (Manage)
    * @property {string} role - member role (owner, writer, member)
    * @property {string} text - Text entered in a search
    **/
    /**
     * Name: Oneapp Manage search results. Evid: 1309.
     * Event description: Number of posts found in search in OneApp Manage.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * num_posts_found - Type: numeric. Desc: Number of posts found in search
     *
     * origin - Type: string. Desc: Where tabs was opened (Manage)
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * text - Type: string. Desc: Text entered in a search
     * @param {oneappManageSearchResultsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneappManageSearchResults = function (params) {
        return this.bi.log(__assign({ evid: 1309 }, params));
    };
    /**
    * @typedef {Object} categoryDeletedParams
    * @property {string} category_id - category id
    * @property {GUID} instance_id - instance
    * @property {string} language - category language
    * @property {GUID} biToken - msid
    * @property {string} origin - post page, post editor, drafts
    * @property {string} translation_id - the id of the translated category
    **/
    /**
     * Name: Category deleted. Evid: 376.
     * Event description: When a category is deleted.
    
     * category_id - Type: string. Desc: category id
     *
     * instance_id - Type: guid. Desc: instance
     *
     * language - Type: string. Desc: category language
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: post page, post editor, drafts
     *
     * translation_id - Type: string. Desc: the id of the translated category
     * @param {categoryDeletedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.categoryDeleted = function (params) {
        return this.bi.log(__assign({ evid: 376 }, params));
    };
    /**
    * @typedef {Object} multilingualLanguagePickerLanguageClickParams
    * @property {GUID} instance_id - instance id
    * @property {boolean} isFilter - is the language picker a filter?
    * @property {string} language_selected - language selected
    * @property {GUID} biToken - instance id
    * @property {string} origin - origin
    * @property {string} role - role
    * @property {string} tabName - tab name
    **/
    /**
     * Name: Multilingual - language picker language click. Evid: 416.
     * Event description: Triggered when the user chooses a language from the language picker.
    
     * instance_id - Type: guid. Desc: instance id
     *
     * isFilter - Type: bool. Desc: is the language picker a filter?
     *
     * language_selected - Type: string. Desc: language selected
     *
     * biToken - Type: guid. Desc: instance id
     *
     * origin - Type: string. Desc: origin
     *
     * role - Type: string. Desc: role
     *
     * tabName - Type: string. Desc: tab name
     * @param {multilingualLanguagePickerLanguageClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.multilingualLanguagePickerLanguageClick = function (params) {
        return this.bi.log(__assign({ evid: 416 }, params));
    };
    /**
    * @typedef {Object} postDraftCreatedParams
    * @property {GUID} app_id - app_id (forum, blog, members)
    * @property {string} community_id - NOT IN USE: community_id (instance of members app)
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_offline - if the event happened offline
    * @property {boolean} is_published - 0 - not published (draft) / 1 - published
    * @property {string} language - for multilingual
    * @property {string} member_id - member_id
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {GUID} original_instance_id - NOT IN USE: in the members app events. holds the child app (forum/blog) instance_id
    * @property {string} post_id - post_id
    * @property {GUID} post_stable_id - stable id
    * @property {string} referral_info - NOT IN USE: external links - facebook, social networks. if from wix then null
    * @property {string} role - member role (owner, writer, member)
    * @property {string} translation_id - the post_stable_id of the translated post
    **/
    /**
     * Name: post draft created. Evid: 305.
     * Event description: triggered when a post draft is created (first save).
    
     * app_id - Type: guid. Desc: app_id (forum, blog, members)
     *
     * community_id - Type: string. Desc: NOT IN USE: community_id (instance of members app)
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_offline - Type: bool. Desc: if the event happened offline
     *
     * is_published - Type: bool. Desc: 0 - not published (draft) / 1 - published
     *
     * language - Type: string. Desc: for multilingual
     *
     * member_id - Type: string. Desc: member_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * original_instance_id - Type: guid. Desc: NOT IN USE: in the members app events. holds the child app (forum/blog) instance_id
     *
     * post_id - Type: string. Desc: post_id
     *
     * post_stable_id - Type: guid. Desc: stable id
     *
     * referral_info - Type: string. Desc: NOT IN USE: external links - facebook, social networks. if from wix then null
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * translation_id - Type: string. Desc: the post_stable_id of the translated post
     * @param {postDraftCreatedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postDraftCreated = function (params) {
        return this.bi.log(__assign({ evid: 305 }, params));
    };
    /**
    * @typedef {Object} hoverOnTooltipParams
    * @property {GUID} instance_id - instance
    * @property {GUID} biToken - msid
    * @property {string} origin - origin
    * @property {string} role - role
    * @property {string} text - the tooltip text
    * @property {string} tooltip_name - tooltip name
    **/
    /**
     * Name: hover on tooltip. Evid: 413.
     * Event description: Fired when the user hovers a tooltip.
    
     * instance_id - Type: guid. Desc: instance
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin
     *
     * role - Type: string. Desc: role
     *
     * text - Type: string. Desc: the tooltip text
     *
     * tooltip_name - Type: string. Desc: tooltip name
     * @param {hoverOnTooltipParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.hoverOnTooltip = function (params) {
        return this.bi.log(__assign({ evid: 413 }, params));
    };
    /**
    * @typedef {Object} oneAppActionSheetOptionClickParams
    * @property {string} action_name - the option the user clicked / selected on the modal
    * @property {string} action_sheet_name - action name
    * @property {GUID} instance_id - instance
    * @property {GUID} biToken - msid
    * @property {string} origin - what triggered this action
    * @property {string} role - role
    * @property {GUID} visitor_id - visitor
    **/
    /**
     * Name: OneApp - Action sheet option click. Evid: 1323.
     * Event description: Generic event to track clicks within an action sheet in OneApp.
    
     * action_name - Type: string. Desc: the option the user clicked / selected on the modal
     *
     * action_sheet_name - Type: string. Desc: action name
     *
     * instance_id - Type: guid. Desc: instance
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: what triggered this action
     *
     * role - Type: string. Desc: role
     *
     * visitor_id - Type: guid. Desc: visitor
     * @param {oneAppActionSheetOptionClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppActionSheetOptionClick = function (params) {
        return this.bi.log(__assign({ evid: 1323 }, params));
    };
    /**
    * @typedef {Object} migrationGiveFeedbackClickParams
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_first - is it the first time the user opens this tab?
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} referral_info - referral_info
    * @property {string} role - role
    **/
    /**
     * Name: Migration -> Give feedback click. Evid: 395.
     * Event description: triggered when users click on Give feedback.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_first - Type: bool. Desc: is it the first time the user opens this tab?
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * referral_info - Type: string. Desc: referral_info
     *
     * role - Type: string. Desc: role
     * @param {migrationGiveFeedbackClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationGiveFeedbackClick = function (params) {
        return this.bi.log(__assign({ evid: 395 }, params));
    };
    /**
    * @typedef {Object} appInstallAutopilotParams
    * @property {string} uuid - null
    * @property {string} app_id - installed app id
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: app install autopilot. Evid: 402.
     * Event description: sends if app was installed, used for autopilot for post page migration.
    
     * uuid - Type: string.
     *
     * app_id - Type: string. Desc: installed app id
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {appInstallAutopilotParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.appInstallAutopilot = function (params) {
        return this.bi.log(__assign({ evid: 402 }, params));
    };
    /**
    * @typedef {Object} migrationUpdateSuccessModalOpenedParams
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_first - is it the first time the user opens this tab?
    * @property {string} migration_status - First time, In progress, Done (after finishing migration)
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} referral_info - referral_info
    * @property {string} role - role
    **/
    /**
     * Name: Migration -> Update success modal opened. Evid: 393.
     * Event description: triggered when Migration Update URLs modal actually open.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_first - Type: bool. Desc: is it the first time the user opens this tab?
     *
     * migration_status - Type: string. Desc: First time, In progress, Done (after finishing migration)
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * referral_info - Type: string. Desc: referral_info
     *
     * role - Type: string. Desc: role
     * @param {migrationUpdateSuccessModalOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationUpdateSuccessModalOpened = function (params) {
        return this.bi.log(__assign({ evid: 393 }, params));
    };
    /**
    * @typedef {Object} migrationQuickMigrationAdParams
    * @property {string} action - switch, find out more, later, close
    * @property {boolean} do_not_show_again - do not show again flag
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - new blog 6th button, old blog 6th button, old blog manager, add panel
    * @property {string} post_id - post id
    **/
    /**
     * Name: Migration -> Quick Migration ad action. Evid: 397.
     * Event description: Whenever the user clicks one option from the switch to new blog ad. The ad appears within the editor, on the new and old blog 6th button and on the old blog manager..
    
     * action - Type: string. Desc: switch, find out more, later, close
     *
     * do_not_show_again - Type: bool. Desc: do not show again flag
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: new blog 6th button, old blog 6th button, old blog manager, add panel
     *
     * post_id - Type: string. Desc: post id
     * @param {migrationQuickMigrationAdParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationQuickMigrationAd = function (params) {
        return this.bi.log(__assign({ evid: 397 }, params));
    };
    /**
    * @typedef {Object} authorOfflineCreatedParams
    * @property {GUID} author_id - Author id which was created
    * @property {string} author_name - Author name
    * @property {string} author_role - Currently "Offline", might be reused later
    * @property {string} author_title - author title
    * @property {boolean} has_picture - TRUE if a picture is assigned for created author
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Author (offline) created. Evid: 365.
     * Event description: Created an offline author.
    
     * author_id - Type: guid. Desc: Author id which was created
     *
     * author_name - Type: string. Desc: Author name
     *
     * author_role - Type: string. Desc: Currently "Offline", might be reused later
     *
     * author_title - Type: string. Desc: author title
     *
     * has_picture - Type: bool. Desc: TRUE if a picture is assigned for created author
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {authorOfflineCreatedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.authorOfflineCreated = function (params) {
        return this.bi.log(__assign({ evid: 365 }, params));
    };
    /**
    * @typedef {Object} oneappBlogSearchResultsParams
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {number} num_of_items - Number of items found
    * @property {string} origin - Where tabs was opened (Manage)
    * @property {string} role - member role (owner, writer, member)
    * @property {string} tab_name - Posts, categories, Authors, Tags
    * @property {string} text - Text entered in a search
    **/
    /**
     * Name: Oneapp - blog search results. Evid: 1337.
     * Event description: Number of posts found in search in OneApp Manage.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * num_of_items - Type: numeric. Desc: Number of items found
     *
     * origin - Type: string. Desc: Where tabs was opened (Manage)
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * tab_name - Type: string. Desc: Posts, categories, Authors, Tags
     *
     * text - Type: string. Desc: Text entered in a search
     * @param {oneappBlogSearchResultsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneappBlogSearchResults = function (params) {
        return this.bi.log(__assign({ evid: 1337 }, params));
    };
    /**
    * @typedef {Object} blogCategoryInfoChangedParams
    * @property {GUID} app_id - app_id (forum, blog, members)
    * @property {number} category_count - current amount of categories i the blog
    * @property {string} category_id - category_id
    * @property {boolean} category_label - category label was changed
    * @property {string} community_id - community_id (instance of members app)
    * @property {boolean} image - image was edited (OneApp only)
    * @property {GUID} instance_id - instance_id
    * @property {string} language - language
    * @property {string} member_id - member_id
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
    * @property {string} referral_info - external links - facebook, social networks. if from wix then null
    * @property {string} role - member role (owner, writer, member)
    * @property {boolean} seo_description - seo_description was edited (OneApp only)
    * @property {boolean} seo_name - seo_name was changed
    * @property {string} translation_id - the id of the the translated category
    **/
    /**
     * Name: blog category info changed. Evid: 312.
     * Event description: triggered when an exiting category edited in the app settings - title or description.
    
     * app_id - Type: guid. Desc: app_id (forum, blog, members)
     *
     * category_count - Type: numeric. Desc: current amount of categories i the blog
     *
     * category_id - Type: string. Desc: category_id
     *
     * category_label - Type: bool. Desc: category label was changed
     *
     * community_id - Type: string. Desc: community_id (instance of members app)
     *
     * image - Type: bool. Desc: image was edited (OneApp only)
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * language - Type: string. Desc: language
     *
     * member_id - Type: string. Desc: member_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * original_instance_id - Type: guid. Desc: in the members app events. holds the child app (forum/blog) instance_id
     *
     * referral_info - Type: string. Desc: external links - facebook, social networks. if from wix then null
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * seo_description - Type: bool. Desc: seo_description was edited (OneApp only)
     *
     * seo_name - Type: bool. Desc: seo_name was changed
     *
     * translation_id - Type: string. Desc: the id of the the translated category
     * @param {blogCategoryInfoChangedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.blogCategoryInfoChanged = function (params) {
        return this.bi.log(__assign({ evid: 312 }, params));
    };
    /**
    * @typedef {Object} searchInBlogBoParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {number} num_posts_found - Number of posts found in search
    * @property {string} origin - Search origin
    * @property {string} role - member role (owner, writer, member)
    * @property {string} text - Text entered in a search
    **/
    /**
     * Name: Search in Blog BO. Evid: 343.
     * Event description: Search in Blog BO.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * num_posts_found - Type: numeric. Desc: Number of posts found in search
     *
     * origin - Type: string. Desc: Search origin
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * text - Type: string. Desc: Text entered in a search
     * @param {searchInBlogBoParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.searchInBlogBo = function (params) {
        return this.bi.log(__assign({ evid: 343 }, params));
    };
    /**
    * @typedef {Object} fileUploadedParams
    * @property {string} file_ext - File extension
    * @property {string} file_id - The file identifier (null if not successful)
    * @property {number} file_size - The size of the file being uploaded (in bytes)
    * @property {GUID} instance_id - null
    * @property {string} mime_type - File type
    * @property {GUID} biToken - metasite id
    * @property {string} origin - post (for now just post)
    * @property {string} post_id - post_id
    * @property {string} role - role
    * @property {boolean} success - 0 - upload failed / 1 - upload successful
    **/
    /**
     * Name: File uploaded. Evid: 317.
     * Event description: Event triggered when a person tries to upload a file to a Blog post.
    
     * file_ext - Type: string. Desc: File extension
     *
     * file_id - Type: string. Desc: The file identifier (null if not successful)
     *
     * file_size - Type: numeric. Desc: The size of the file being uploaded (in bytes)
     *
     * instance_id - Type: guid.
     *
     * mime_type - Type: string. Desc: File type
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * origin - Type: string. Desc: post (for now just post)
     *
     * post_id - Type: string. Desc: post_id
     *
     * role - Type: string. Desc: role
     *
     * success - Type: bool. Desc: 0 - upload failed / 1 - upload successful
     * @param {fileUploadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.fileUploaded = function (params) {
        return this.bi.log(__assign({ evid: 317 }, params));
    };
    /**
    * @typedef {Object} blogSettingsSavedInBmParams
    * @property {number} amp_changed - 1 - changed, 0 - didn't
    * @property {number} amp_enabled - 1 - enabled, 0 - didn't
    * @property {string} app_id - app_id
    * @property {number} emailmembers_changed - 1 - changed, 0 - didn't
    * @property {number} emailmembers_enabled - 1 - enabled, 0 - didn't
    * @property {number} emailsubscribers_changed - 1 - changed, 0 - didn't
    * @property {number} emailsubscribers_enabled - 1 - enabled, 0 - didn't
    * @property {GUID} instance_id - null
    * @property {number} logo_changed - 1 - added/changed, 0 - didn't
    * @property {GUID} biToken - null
    * @property {string} origin - BM_posts
    * @property {string} role - role
    * @property {number} schema_changed - 1 - changed, 0 - didn't
    * @property {number} schema_enabled - 1 - enabled, 0 - didn't
    * @property {string} settings - json string with values 0 - disabled, 1 - enabled, e.g. {AMP: 1, Schema: 0, logo : 0 }
    **/
    /**
     * Name: Blog settings saved (in BM). Evid: 361.
     * Event description: Blog settings saved (in BM).
    
     * amp_changed - Type: numeric. Desc: 1 - changed, 0 - didn't
     *
     * amp_enabled - Type: numeric. Desc: 1 - enabled, 0 - didn't
     *
     * app_id - Type: string. Desc: app_id
     *
     * emailmembers_changed - Type: numeric. Desc: 1 - changed, 0 - didn't
     *
     * emailmembers_enabled - Type: numeric. Desc: 1 - enabled, 0 - didn't
     *
     * emailsubscribers_changed - Type: numeric. Desc: 1 - changed, 0 - didn't
     *
     * emailsubscribers_enabled - Type: numeric. Desc: 1 - enabled, 0 - didn't
     *
     * instance_id - Type: guid.
     *
     * logo_changed - Type: numeric. Desc: 1 - added/changed, 0 - didn't
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: BM_posts
     *
     * role - Type: string. Desc: role
     *
     * schema_changed - Type: numeric. Desc: 1 - changed, 0 - didn't
     *
     * schema_enabled - Type: numeric. Desc: 1 - enabled, 0 - didn't
     *
     * settings - Type: string. Desc: json string with values 0 - disabled, 1 - enabled, e.g. {AMP: 1, Schema: 0, logo : 0 }
     * @param {blogSettingsSavedInBmParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.blogSettingsSavedInBm = function (params) {
        return this.bi.log(__assign({ evid: 361 }, params));
    };
    /**
    * @typedef {Object} postDeletedParams
    * @property {GUID} app_id - app_id (forum, blog, members)
    * @property {string} category_ids - category_ids. JSON array string
    * @property {string} community_id - community_id (instance of members app)
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_published - 0 - not published (draft) / 1 - published
    * @property {string} language - for multilingual
    * @property {string} member_id - member_id
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
    * @property {string} post_id - post_id
    * @property {GUID} post_stable_id - stable id
    * @property {string} referral_info - external links - facebook, social networks. if from wix then null
    * @property {string} role - member role (owner, writer, member)
    * @property {GUID} site_member_id - site_member_id
    * @property {string} translation_id - translation id
    **/
    /**
     * Name: post deleted. Evid: 306.
     * Event description: triggered when post deleted.
    
     * app_id - Type: guid. Desc: app_id (forum, blog, members)
     *
     * category_ids - Type: string. Desc: category_ids. JSON array string
     *
     * community_id - Type: string. Desc: community_id (instance of members app)
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_published - Type: bool. Desc: 0 - not published (draft) / 1 - published
     *
     * language - Type: string. Desc: for multilingual
     *
     * member_id - Type: string. Desc: member_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * original_instance_id - Type: guid. Desc: in the members app events. holds the child app (forum/blog) instance_id
     *
     * post_id - Type: string. Desc: post_id
     *
     * post_stable_id - Type: guid. Desc: stable id
     *
     * referral_info - Type: string. Desc: external links - facebook, social networks. if from wix then null
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * translation_id - Type: string. Desc: translation id
     * @param {postDeletedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postDeleted = function (params) {
        return this.bi.log(__assign({ evid: 306 }, params));
    };
    /**
    * @typedef {Object} unpublishPostParams
    * @property {string} action - revert to draft
    * @property {GUID} instance_id - null
    * @property {string} language - for multilingual
    * @property {GUID} biToken - null
    * @property {string} origin - post page, post editor
    * @property {string} post_id - post id
    * @property {GUID} post_stable_id - post stable id
    * @property {string} translation_id - posts stable id of the original translated post
    **/
    /**
     * Name: Unpublish post. Evid: 332.
     * Event description: When a post is unpublished..
    
     * action - Type: string. Desc: revert to draft
     *
     * instance_id - Type: guid.
     *
     * language - Type: string. Desc: for multilingual
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: post page, post editor
     *
     * post_id - Type: string. Desc: post id
     *
     * post_stable_id - Type: guid. Desc: post stable id
     *
     * translation_id - Type: string. Desc: posts stable id of the original translated post
     * @param {unpublishPostParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.unpublishPost = function (params) {
        return this.bi.log(__assign({ evid: 332 }, params));
    };
    /**
    * @typedef {Object} oneAppSharePostButtonClick304Params
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - Instant after publish or later while reading (from banner)
    * @property {GUID} post_id - post_id
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: OneApp Share post button click. Evid: 304.
     * Event description: User clicked on share post button (to copy url).
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: Instant after publish or later while reading (from banner)
     *
     * post_id - Type: guid. Desc: post_id
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {oneAppSharePostButtonClick304Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppSharePostButtonClick304 = function (params) {
        return this.bi.log(__assign({ evid: 304 }, params));
    };
    /**
    * @typedef {Object} blogManagerOpenClickBoParams
    * @property {string} app_id - app_id (forum, blog, members)
    * @property {string} community_id - community_id (instance of members app)
    * @property {GUID} instance_id - instance_id
    * @property {string} member_id - member_id
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
    * @property {string} referral_info - external links - facebook, social networks. if from wix then null
    * @property {string} role - member role (owner, writer, member)
    **/
    /**
     * Name: blog manager open click (BO). Evid: 300.
     * Event description: triggered when click on Manage posts CTA.
    
     * app_id - Type: string. Desc: app_id (forum, blog, members)
     *
     * community_id - Type: string. Desc: community_id (instance of members app)
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * member_id - Type: string. Desc: member_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * original_instance_id - Type: guid. Desc: in the members app events. holds the child app (forum/blog) instance_id
     *
     * referral_info - Type: string. Desc: external links - facebook, social networks. if from wix then null
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     * @param {blogManagerOpenClickBoParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.blogManagerOpenClickBo = function (params) {
        return this.bi.log(__assign({ evid: 300 }, params));
    };
    /**
    * @typedef {Object} migrationHomePageOpenedParams
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_first - is it the first time the user opens this tab?
    * @property {boolean} is_full_width - is_full_width (with left nav or not)
    * @property {string} migration_status - First time, In progress, Done (after finishing migration)
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} referral_info - referral_info
    * @property {string} role - role
    **/
    /**
     * Name: Migration -> home page opened. Evid: 380.
     * Event description: triggered when Migration home page opened actually open.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_first - Type: bool. Desc: is it the first time the user opens this tab?
     *
     * is_full_width - Type: bool. Desc: is_full_width (with left nav or not)
     *
     * migration_status - Type: string. Desc: First time, In progress, Done (after finishing migration)
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * referral_info - Type: string. Desc: referral_info
     *
     * role - Type: string. Desc: role
     * @param {migrationHomePageOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationHomePageOpened = function (params) {
        return this.bi.log(__assign({ evid: 380 }, params));
    };
    /**
    * @typedef {Object} editorSettingsLayoutTabParams
    * @property {string} app_id - app_id
    * @property {string} editor_layout - Computer/Mobile
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - Post Page Settings, app settings (feed)
    * @property {string} role - role
    * @property {string} settings - setting name, i.e. layout, post load, posts per page
    * @property {string} tab_name - All poss feed/Category Page
    * @property {string} value - setting chosen, i.e. Tiled (for layout), On scroll down (for post load), 7 (for posts per page)
    * @property {number} value_pagination_size - number of posts per page/per load
    * @property {string} value_pagination_type - With page numbers, on scroll....
    * @property {string} widget_name - Feed, Custom Feed
    **/
    /**
     * Name: editor - settings layout tab. Evid: 357.
     * Event description: Layout settings changed in editor. For custom feed all settings are returned in value field, for blog app it's spread to value, value_pagination_type, value_pagination_size. Use "settings" field to distinguish what was changed, origin - to identify blog app (main feed) and custom feed.
    
     * app_id - Type: string. Desc: app_id
     *
     * editor_layout - Type: string. Desc: Computer/Mobile
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: Post Page Settings, app settings (feed)
     *
     * role - Type: string. Desc: role
     *
     * settings - Type: string. Desc: setting name, i.e. layout, post load, posts per page
     *
     * tab_name - Type: string. Desc: All poss feed/Category Page
     *
     * value - Type: string. Desc: setting chosen, i.e. Tiled (for layout), On scroll down (for post load), 7 (for posts per page)
     *
     * value_pagination_size - Type: numeric. Desc: number of posts per page/per load
     *
     * value_pagination_type - Type: string. Desc: With page numbers, on scroll....
     *
     * widget_name - Type: string. Desc: Feed, Custom Feed
     * @param {editorSettingsLayoutTabParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.editorSettingsLayoutTab = function (params) {
        return this.bi.log(__assign({ evid: 357 }, params));
    };
    /**
    * @typedef {Object} oneAppPostSwipeActionParams
    * @property {GUID} instance_id - null
    * @property {boolean} is_published - is_published
    * @property {GUID} biToken - msid
    * @property {string} origin - Manage
    * @property {string} post_id - post_id
    * @property {GUID} post_stable_id - stable id
    * @property {string} role - member role (owner, writer, member)
    * @property {string} tab_name - tab name in Manage (Published/Drafts)
    **/
    /**
     * Name: OneApp Post Swipe action. Evid: 1303.
     * Event description: User did a swipe action in OneApp.
    
     * instance_id - Type: guid.
     *
     * is_published - Type: bool. Desc: is_published
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: Manage
     *
     * post_id - Type: string. Desc: post_id
     *
     * post_stable_id - Type: guid. Desc: stable id
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * tab_name - Type: string. Desc: tab name in Manage (Published/Drafts)
     * @param {oneAppPostSwipeActionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppPostSwipeAction = function (params) {
        return this.bi.log(__assign({ evid: 1303 }, params));
    };
    /**
    * @typedef {Object} newCategoryClickParams
    * @property {GUID} app_id - app_id (forum, blog, members)
    * @property {string} community_id - community_id (instance of members app)
    * @property {GUID} instance_id - instance_id
    * @property {string} language - for multilingual
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} role - member role (owner, writer, member)
    * @property {GUID} site_member_id - site_member_id
    **/
    /**
     * Name: new category click. Evid: 375.
     * Event description: triggered when click on "new category" CTA.
    
     * app_id - Type: guid. Desc: app_id (forum, blog, members)
     *
     * community_id - Type: string. Desc: community_id (instance of members app)
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * language - Type: string. Desc: for multilingual
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * role - Type: string. Desc: member role (owner, writer, member)
     *
     * site_member_id - Type: guid. Desc: site_member_id
     * @param {newCategoryClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.newCategoryClick = function (params) {
        return this.bi.log(__assign({ evid: 375 }, params));
    };
    /**
    * @typedef {Object} paidPostInsidePostEditorSidebarParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} option - Get Started/Learn More
    * @property {string} role - role
    **/
    /**
     * Name: Paid Post inside post editor sidebar. Evid: 377.
     * Event description: Option chosen inside Paid Post in post editor sidebar.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * option - Type: string. Desc: Get Started/Learn More
     *
     * role - Type: string. Desc: role
     * @param {paidPostInsidePostEditorSidebarParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.paidPostInsidePostEditorSidebar = function (params) {
        return this.bi.log(__assign({ evid: 377 }, params));
    };
    /**
    * @typedef {Object} migrationMaybeLaterClickParams
    * @property {GUID} instance_id - instance_id
    * @property {boolean} is_first - is it the first time the user opens this tab?
    * @property {GUID} biToken - msid
    * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
    * @property {string} referral_info - referral_info
    * @property {string} role - role
    **/
    /**
     * Name: Migration -> Maybe later click. Evid: 382.
     * Event description: triggered when users click on Maybe later click.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * is_first - Type: bool. Desc: is it the first time the user opens this tab?
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
     *
     * referral_info - Type: string. Desc: referral_info
     *
     * role - Type: string. Desc: role
     * @param {migrationMaybeLaterClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationMaybeLaterClick = function (params) {
        return this.bi.log(__assign({ evid: 382 }, params));
    };
    return Logger;
}());
export { Logger };
export default init;
export function getLoggerConf() {
    return {
        src: 69,
        endpoint: 'blog-app-users'
    };
}
//# sourceMappingURL=index.js.map